import React, { useState, useEffect, useRef, Suspense, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import SysOwnerSideBar from './SysOwnerSidebar';
import * as mui from '@mui/material';
import ResponsiveContainer from '../../layout/Container';
import ErrorBoundary from '../../common/ErrorBoundery';
import SearchAppBar from '../../common/Appbar';
import Separator from '../../layout/Separator';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import Groups from '@mui/icons-material/Groups';
import People from '@mui/icons-material/People';
import PlaylistAddCheck from '@mui/icons-material/PlaylistAddCheck';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useParams } from 'react-router-dom';
import appService from '../../../services/ApplicationService';
import HRService from '../../../services/HrService';
import ReactSelect from 'react-select';
import './styles.css';
import roleService from '../../../services/RoleService';
import DynamicTabs from '../../common/DynamicTabs';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import RateReviewIcon from '@mui/icons-material/RateReview';
import uarService from '../../../services/UARService';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import SendIcon from '@mui/icons-material/Send';
import EmailIcon from '@mui/icons-material/Email';
import SettingsIcon from '@mui/icons-material/Settings';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import LogoLoader from '../../common/LogoLoader';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Select from '@mui/material/Select';
import ConflictUserRow from './ConflictUserRow';
import Avatar from '@mui/material/Avatar';
import UARReviewDashboard from './UARReviewDashboard';
// Import recharts components
import { PieChart, Pie, Cell, Legend, Tooltip as RechartsTooltip, ResponsiveContainer as RechartsResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid } from 'recharts';



// Import Material UI icons
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Material UI components
import {
    Card,
    CardContent,
    CardActionArea,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    Box,
    Chip,
    Grid,
    Paper,
    Divider,
    Stack,
    LinearProgress,
    Alert,
    Snackbar,
    TableContainer, // Add TableContainer to the imports
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    ListItemSecondaryAction,
    TextField,
    InputAdornment
} from '@mui/material';

// Common components
import Modal from '../../common/Modal';
import MultipleSelect from '../../common/MultipleSelect';
import NormalTextField from '../../common/NormalTextField';
import ActionPanel from '../../common/ActionPanel';
import UARStatsDisplay from '../../common/UARStats';
import UARSteps from '../../common/UARStepper';
import UARRoleList from '../../common/UARRoleList';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CloseIcon from '@mui/icons-material/Close';
import UARCACheck from './UARCACheck';

const DataTable = React.lazy(() => import('../../common/DataGrid'));

// Custom theme for premium look
const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
            light: '#4791db',
            dark: '#115293',
        },
        secondary: {
            main: '#4caf50',
            light: '#80e27e',
            dark: '#087f23',
        },
        error: {
            main: '#f44336',
        },
        warning: {
            main: '#ff9800',
        },
        info: {
            main: '#2196f3',
        },
        success: {
            main: '#4caf50',
        },
        background: {
            default: '#f8fafc',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h5: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 500,
        },
        subtitle1: {
            fontWeight: 500,
        },
        subtitle2: {
            fontWeight: 400,
        },
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                    '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    textTransform: 'none',
                    fontWeight: 500,
                },
                containedPrimary: {
                    boxShadow: '0 3px 5px rgba(0,0,0,0.1)',
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                    '&:before': {
                        display: 'none',
                    },
                    marginBottom: 16,
                },
            },
        },
    },
});

// Status chip component for consistent status display
const StatusChip = ({ status }) => {
    let color = 'default';
    let label = status || 'Unknown';
    
    switch(status) {
        case 'Approved':
            color = 'success';
            break;
        case 'Rejected':
            color = 'error';
            break;
        case 'Pending Review':
            color = 'warning';
            break;
        case 'Review In-Progress':
            color = 'info';
            break;
        case 'Not Started':
            color = 'default';
            break;
        default:
            color = 'default';
    }
    
    return <Chip label={label} color={color} size="small" />;
};

// Redesigned Role Review Panel component to show role details and users in accordion format
// const RoleReviewPanel = ({ role, hrList, rolesForReview, onSendReminder, userswithSOD, appRecord, setOpenMappingModal, setSelectedUser, setSelectedUserEmail }) => {
// ...
// };

// Similar component for role owners
// const RoleOwnerReviewPanel = ({ roleOwner, userswithSOD, appRecord, onSendReminder, setOpenMappingModal, setSelectedUser, setSelectedUserEmail }) => {
// ...
// };

const UserAccessReviewData = () => {

    const { id } = useParams();
    const { phase } = useParams();
    const [apps, setApps] = useState([]);
    const [uarData, setUARData] = useState([]);
    const [appRecord, setAppRecord] = useState([]);

    const [uniqueRoles, setUniqueRoles] = useState(0);
    const [uniqueUsers, setUniqueUsers] = useState(0);

    const [uarStatus, setUARStatus] = useState('');
    const [uarFile, setUARFile] = useState('');
    const [uarCycle, setUARCycle] = useState('');
    const [uarSODViolation, setUARSODViolation] = useState(false); // Initialize to false
    const [uarSoDData, setUARSODDATA] = useState([]);
    const [rolesForReview, setRolesForReview] = useState([]);
    const [openUARSetupModal, setOpenUARSetupModal] = useState(false);
    const [roleOwnerList, setRoleOwnerList] = useState([]);
    const [assignedOwner, setAssignedOwner] = useState({});
    const [selectedOwners, setSelectedOwners] = useState({});
    const [roleOwnerData, setRoleOwnerdata] = useState([]);
    const [roleData, setRoleData] = useState({});
    const [activeUsers, setActiveUsers] = useState([]);
    const [usersByRole, setUsersByRole] = useState([]);
    const [userswithSOD, setUsersWithSOD] = useState([]);
    const [selectedRole, setSelectedRole] = useState({});
    const [hrList, setHRList] = useState([]);
    const [sodViolation, setSODViolation] = useState(false);
    const [roleOwnerEmail, setRoleOwnerEmail] = useState('');
    const [updatedRoleOwner, setUpdatedRoleOwner] = useState('');
    const [updateRoleOwnerData, setUpdateRoleOwnerData] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedUserEmail, setSelectedUserEmail] = useState('');

    const [roleCount, setRoleCount] = useState(0);
    const [pendingReview, setPendingReviewCount] = useState(0);
    const [needsAction, setNeedsAction] = useState(0);
    const [completed, setCompleted] = useState(0);
    const [stepOne, setStepOne] = useState({});
    const [stepTwo, setStepTwo] = useState({});
    const [stepThree, setStepThree] = useState({});
    const [stepFour, setStepFour] = useState({});
    const [stepFive, setStepFive] = useState({});
    const [uniqueRolesList, setUniqueRolesList] = useState({});

    const [openMappingModal, setOpenMappingModal] = useState(false);
    const [openFilterByRoleModal, setOpenFilterByRoleModal] = useState(false);
    const [openRolesSelectModal, setOpenRolesSelectModal] = useState(false);
    const [chosenRoles, setChosenRoles] = useState([]);
    const navigate = useNavigate();

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [loading, setLoading] = useState(false);

    const [showOnlySodViolations, setShowOnlySodViolations] = useState(false);
    const [filteredRows, setFilteredRows] = useState([]);

    // Add a flag to track if UAR data is currently being fetched
    const [fetchingUARData, setFetchingUARData] = useState(false);

    const [expandedRows, setExpandedRows] = useState([]);
    const [roleUsersMap, setRoleUsersMap] = useState({});
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    const handleBackClick = () => {
        navigate(`/useraccessreview`);
    };

    const handleSendClick = async () => {
        setLoading(true);

        try {
            // UPDATE THE PROGRESS OF THE UAR FILE
        const updated_status = {
            STATUS: 'Review In-Progress'
            };

            const response = await uarService.updateUAR(uarData?.id, updated_status);
            const data = await uarService.sendUARForReview(userswithSOD);

            setSnackbarMessage('Review request sent successfully to all role owners');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            
            setTimeout(() => {
            window.location.reload();
            }, 1500);

        } catch (error) {
            console.error("Error updating UAR status:", error);
            setSnackbarMessage('Failed to send review requests. Please try again.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            setLoading(false);
        }
    };

    const handleOpenFilterByRoleModal = () => {
        setOpenFilterByRoleModal(true);
    };

    const handleCloseFilterByRoleModal = (event, reason) => {
        if (reason == 'backdropClick') {
            setOpenFilterByRoleModal(true)
        }
        else {
            setOpenFilterByRoleModal(false);
        }
    };

    const handleOpenMappingModal = () => {
        setOpenMappingModal(true);
    };

    const handleCloseMappingModal = (event, reason) => {
        if (reason == 'backdropClick') {
            setOpenMappingModal(true)
        }
        else {
            setOpenMappingModal(false);
        }
    };

    const handleCloseRolesSelectModal = (event, reason) => {
        if (reason == 'backdropClick') {
            setOpenRolesSelectModal(true)
        }
        else {
            setOpenRolesSelectModal(false);
        }
    };

    const handleCloseCreateModal = (event, reason) => {
        if (reason == 'backdropClick') {
            setOpenUARSetupModal(true)
        }
        else {
            setOpenUARSetupModal(false);
        }
    };

  
    const handleRoleOwnerUpdate = (selectedOptions) => {

        const roleowner = selectedOptions.value;

        const roleOwnerDetails = hrList.find(item => item.id === roleowner);

        let sodViolation;

        if (roleOwnerDetails.EMAIL_ADDRESS === selectedUserEmail) {
            sodViolation = true
        } else {
            sodViolation = false
        }

        setUpdatedRoleOwner(selectedOptions)

        const updatedData = {
            ...updateRoleOwnerData,
            id: selectedUser,
            ROLE_OWNER: roleowner,
            WITH_SOD_VIOLATION: sodViolation,
        };

        setUpdateRoleOwnerData(updatedData)
    };

    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true);
            try {
                await Promise.all([
                    fetchApp(),
                    fetchUARData(),
                    fetchAppRecord(),
                    fetchRolesRecord(),
                    fetchRoleOwner()
                ]);
                console.log("All initial data loaded successfully");
            } catch (error) {
                console.error("Error loading initial data:", error);
                setSnackbarMessage('Error loading data. Please refresh the page.');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
            } finally {
                setLoading(false);
            }
        };

        fetchAllData();
    }, [id, phase]); // Only reload when the ID or phase changes

    const fetchApp = async () => {
        try {
            const app = await appService.fetchAppsById(id)
            if (app) {
                setApps(app)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const fetchRolesRecord = async () => {
        try {
            // Fetch role owners for this app
            const existingRoleOwners = await roleService.fetchRoleOwnersByApp(id);
            console.log("Fetched role owners:", existingRoleOwners);

            if (existingRoleOwners) {
                setRolesForReview(existingRoleOwners)
            }

            const roles = await appService.fetchAppsRecordById(id);

            const existingRoleNames = new Set(existingRoleOwners.map(owner => owner.ROLE_NAME));

            const filteredRoles = roles.filter(role => !existingRoleNames.has(role.ROLE_NAME));
        } catch (error) {
            console.error('Error fetching role data:', error);
        }
    };

    const fetchRoleOwner = async () => {
        try {
            const hrList = await HRService.fetchAllHRRecords();
            if (hrList) {
                // Use a Set to store unique emails
                const uniqueEmailList = Array.from(
                    new Map(
                        hrList.map(item => [item.EMAIL_ADDRESS, item])
                    ).values()
                );

                console.log("HR records loaded:", uniqueEmailList.length);
                setHRList(uniqueEmailList);

                const email = uniqueEmailList.map(item => ({
                    value: item.id,
                    email: item.EMAIL_ADDRESS,
                    label: `${item.FIRST_NAME} ${item.LAST_NAME} (${item.EMAIL_ADDRESS})`
                }));

                setRoleOwnerList(email);
            }
        } catch (error) {
            console.error('Error fetching role owner:', error);
        }
    };

    const fetchAppRecord = async () => {
        try {
            const appRecord = await appService.fetchAppsRecordById(id)

            if (appRecord) {
                const activeUsers = appRecord.filter(record => record.STATUS !== "Inactive");

                // Create Sets to track unique ROLE_NAMES and EMAIL_ADDRESS
                const uniqueRoleNames = new Set();
                const uniqueEmails = new Set();

                // Loop through activeUsers to populate the Sets
                activeUsers.forEach(record => {
                    uniqueRoleNames.add(record.ROLE_NAME);
                    uniqueEmails.add(record.EMAIL_ADDRESS);
                });

                // Get the count of unique ROLE_NAMES and EMAIL_ADDRESS
                const uniqueRoleNamesCount = uniqueRoleNames.size;
                const uniqueEmailsCount = uniqueEmails.size;

                setUniqueRoles(uniqueRoleNamesCount)
                setUniqueUsers(uniqueEmailsCount)
                setAppRecord(activeUsers);

                const uniqueRoles = [...new Set(appRecord.map(user => user.ROLE_NAME))];

                setUniqueRolesList(uniqueRoles)


            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const fetchUARData = async () => {
        // If already fetching, don't start another fetch
        if (fetchingUARData) {
          
            // Wait for the current fetch to complete
            return new Promise((resolve) => {
                const checkInterval = setInterval(() => {
                    if (!fetchingUARData) {
                        clearInterval(checkInterval);
                        resolve();
                    }
                }, 100);
            });
        }

        setFetchingUARData(true);
        try {
            console.log("Fetching UAR data...");
            const uar = await uarService.fetchUARById(phase);

            if (!uar) {
                console.error("No UAR data returned from service");
                setFetchingUARData(false);
                return null;
            }

            setUARStatus(uar.STATUS);

            if (uar.STATUS === 'Not Started') {
                setStepOne('current');
                setStepTwo('upcoming');
                setStepThree('upcoming');
                setStepFour('upcoming');
                setStepFive('upcoming');
            } else if (uar.STATUS === 'Inscope Roles Defined') {
                setStepOne('complete');
                setStepTwo('current');
                setStepThree('upcoming');
                setStepFour('upcoming');
                setStepFive('upcoming');
            } else if (uar.STATUS === 'User List Generated') {
                setStepOne('complete');
                setStepTwo('complete');
                setStepThree('current');
                setStepFour('upcoming');
                setStepFive('upcoming');
            } else if (uar.STATUS === 'CA Check Completed') {
                setStepOne('complete');
                setStepTwo('complete');
                setStepThree('complete');
                setStepFour('current');
                setStepFive('upcoming');
            } else if (uar.STATUS === 'Review In-Progress') {
                setStepOne('complete');
                setStepTwo('complete');
                setStepThree('complete');
                setStepFour('complete');
                setStepFive('current');
            }

            setUARData(uar);

            try {
                console.log("Fetching users with SOD for app:", id, "cycle:", uar.REVIEW_TAG);
                const users_with_sod = await uarService.getUARSODProcessByAppCycle(id, uar.REVIEW_TAG);

                if (users_with_sod && Array.isArray(users_with_sod)) {
                    console.log(`Got ${users_with_sod.length} users with SOD`);
                    setUsersWithSOD(users_with_sod);

                    // Filter out items where STATUS is either an empty string, null, or undefined
                    const pendingReviewCount = users_with_sod.filter(item => !item.STATUS).length;
                    if (pendingReviewCount) {
                        setPendingReviewCount(pendingReviewCount);
                    }

                    // FILTER REJECTED
                    const rejectedCount = users_with_sod.filter(item => item.STATUS === 'Rejected').length;
                    if (rejectedCount) {
                        setNeedsAction(rejectedCount);
                    }

                    const completedCount = users_with_sod.filter(item => item.STATUS === 'Approved').length;
                    if (completedCount) {
                        setCompleted(completedCount);
                    }

                    const roleCount = users_with_sod.length;
                    if (roleCount) {
                        setRoleCount(roleCount);
                    }
                } else {
                    console.log("No SOD data returned or invalid format");
                    
                    // If no users with SOD found but we have appRecord data, create placeholder data
                    if (appRecord && appRecord.length > 0) {
                        console.log("Using appRecord as fallback data source");
                        const placeholderData = [];
                        
                        // Get unique roles
                        const uniqueRoles = [...new Set(appRecord.map(user => user.ROLE_NAME))];
                        
                        // Create records for each role
                        uniqueRoles.forEach(roleName => {
                            const usersWithRole = appRecord.filter(user => user.ROLE_NAME === roleName);
                            usersWithRole.forEach((user, index) => {
                                placeholderData.push({
                                    id: `fallback-${index}-${Math.random().toString(36).substring(2, 9)}`,
                                    APP_NAME: id,
                                    UAR_FILE: uar.id,
                                    EMAIL_ADDRESS: user.EMAIL_ADDRESS || '',
                                    ROLE_NAME: roleName || '',
                                    FIRST_NAME: user.FIRST_NAME || '',
                                    LAST_NAME: user.LAST_NAME || '',
                                });
                            });
                        });
                        
                        if (placeholderData.length > 0) {
                            console.log(`Created ${placeholderData.length} placeholder records from appRecord`);
                            setUsersWithSOD(placeholderData);
                        }
                    }
                }
            } catch (error) {
                console.error('Error fetching uar sod:', error);
            }

            try {
                const chosen_roles = await uarService.fetchInscopeRolesByUARFile(uar.id);
                if (chosen_roles && chosen_roles.length > 0) {
                    // Map through chosen_roles and create a list with both id and role names
                    const rolesWithIds = chosen_roles.map((role, index) => ({
                        id: index,
                        roleID: role.id,       // Create a unique id using the index
                        ROLE_NAME: role.ROLE_NAMES, // Add the ROLE_NAME
                    }));

                    if (rolesWithIds) {
                        setChosenRoles(rolesWithIds);
                    }
                }
            } catch (error) {
                console.error('Error fetching chosen roles:', error);
            }

            setFetchingUARData(false);
            return uar;
        } catch (error) {
            console.error('Error fetching UAR data:', error);
            // Rethrow the error to propagate it to the caller
            setFetchingUARData(false);
            throw error;
        }
    };

    // Fix the role details click handler to properly toggle rows and load data
    const handleReviewDetailsClick = async (event, phase) => {
      event.stopPropagation(); // Prevent event from bubbling up
      
      const rowId = phase.id;
        const roleName = phase.ROLE_NAME;
      
      console.log(`Toggling details for role: ${roleName}, rowId: ${rowId}`);
      
      // Toggle expanded status
      const isCurrentlyExpanded = expandedRows.includes(rowId);
      
      if (isCurrentlyExpanded) {
        // If already expanded, collapse it
        setExpandedRows(prevRows => prevRows.filter(id => id !== rowId));
        return;
      }
      
      // Otherwise expand and load data if needed
      setExpandedRows(prevRows => [...prevRows, rowId]);
        
        // Show loading state immediately
      setRoleUsersMap(prev => ({
        ...prev,
        [rowId]: [{
            id: `loading-${Date.now()}`,
            ROLE_NAME: roleName,
          FIRST_NAME: 'Loading',
          LAST_NAME: 'Data...',
            EMAIL_ADDRESS: 'Please wait while we fetch user data',
            STATUS: 'Pending'
        }]
      }));
      
      try {
        // Find users with this role
        const usersForRole = userswithSOD.filter(user => 
          user.ROLE_NAME === roleName ||
          (user.ROLE_NAME && roleName && user.ROLE_NAME.toLowerCase() === roleName.toLowerCase())
        );
        
        console.log(`Found ${usersForRole.length} users with role ${roleName}`);
        
        if (usersForRole.length > 0) {
          setRoleUsersMap(prev => ({
            ...prev,
            [rowId]: usersForRole
          }));
                return;
        }
        
        // If no users found, try with appRecord as fallback
        const appRecordUsers = appRecord.filter(user => 
          (user.ROLE_NAME === roleName || 
           (user.ROLE_NAME && roleName && user.ROLE_NAME.toLowerCase() === roleName.toLowerCase())) &&
          user.STATUS !== "Inactive"
        );
        
        if (appRecordUsers.length > 0) {
          const mappedUsers = appRecordUsers.map(user => ({
            id: `app-record-${Math.random().toString(36).substring(2, 9)}`,
            ROLE_NAME: roleName,
            FIRST_NAME: user.FIRST_NAME || '',
            LAST_NAME: user.LAST_NAME || '',
            EMAIL_ADDRESS: user.EMAIL_ADDRESS || '',
            STATUS: 'Pending Review'
          }));
          
          setRoleUsersMap(prev => ({
            ...prev,
            [rowId]: mappedUsers
          }));
          return;
        }
        
        // If still no users found
        setRoleUsersMap(prev => ({
          ...prev,
          [rowId]: [{
            id: `no-users-${Date.now()}`,
            ROLE_NAME: roleName,
            FIRST_NAME: 'No',
            LAST_NAME: 'Users',
            EMAIL_ADDRESS: 'No users found with this role',
            STATUS: 'N/A'
          }]
        }));
        
      } catch (error) {
        console.error('Error loading users:', error);
        setRoleUsersMap(prev => ({
          ...prev,
          [rowId]: [{
            id: `error-${Date.now()}`,
            ROLE_NAME: roleName,
            FIRST_NAME: 'Error',
            LAST_NAME: 'Loading',
            EMAIL_ADDRESS: 'Failed to load user data',
            STATUS: 'Error'
          }]
        }));
      }
    };

    // Fix the role owner click handler
    const handleReviewDetailsClickByRoleOwner = async (event, phase) => {
      event.stopPropagation(); // Prevent event from bubbling up
      
        const rowId = phase.id;
        const roleOwnerId = phase.OWNERID;
      const ownerName = phase.ROLE_OWNER;
        
      console.log(`Toggling details for owner: ${ownerName}, rowId: ${rowId}`);
        
        // Toggle expanded status
      const isCurrentlyExpanded = expandedRows.includes(rowId);
      
      if (isCurrentlyExpanded) {
        // If already expanded, collapse it
        setExpandedRows(prevRows => prevRows.filter(id => id !== rowId));
        return;
      }
      
      // Otherwise expand and load data if needed
      setExpandedRows(prevRows => [...prevRows, rowId]);
      
      // Show loading state immediately
            setRoleUsersMap(prev => ({
                ...prev,
                [rowId]: [{
                    id: `loading-${Date.now()}`,
          ROLE_OWNER: ownerName,
                    FIRST_NAME: 'Loading',
          LAST_NAME: 'Data...',
                    EMAIL_ADDRESS: 'Please wait while we fetch user data',
                    STATUS: 'Pending'
                }]
            }));
            
      try {
        // Find users assigned to this owner
        const usersWithOwner = userswithSOD.filter(user => user.ROLE_OWNER === roleOwnerId);
        
        console.log(`Found ${usersWithOwner.length} users assigned to owner ${ownerName}`);
        
        if (usersWithOwner.length > 0) {
                setRoleUsersMap(prev => ({
                    ...prev,
            [rowId]: usersWithOwner
          }));
          return;
        }
        
        // If no users found
                setRoleUsersMap(prev => ({
                    ...prev,
                    [rowId]: [{
            id: `no-users-${Date.now()}`,
            ROLE_OWNER: ownerName,
                        FIRST_NAME: 'No',
                        LAST_NAME: 'Users',
            EMAIL_ADDRESS: 'No users assigned to this reviewer',
                        STATUS: 'N/A'
                    }]
                }));
                
      } catch (error) {
        console.error('Error loading users:', error);
        setRoleUsersMap(prev => ({
          ...prev,
          [rowId]: [{
            id: `error-${Date.now()}`,
            ROLE_OWNER: ownerName,
            FIRST_NAME: 'Error',
            LAST_NAME: 'Loading',
            EMAIL_ADDRESS: 'Failed to load user data',
            STATUS: 'Error'
          }]
        }));
        }
    };


    const handleUpdateReviewerClick = (event, phase) => {

        const selected_user = userswithSOD.find(user => user.EMAIL_ADDRESS === phase.EMAIL_ADDRESS && user.ROLE_NAME === phase.ROLE_NAME);

        if (selected_user) {
            setSelectedUser(selected_user.id);
            setSelectedUserEmail(selected_user.EMAIL_ADDRESS)

            setOpenMappingModal(true);
        }

    };

    const handleSendFollowUpEmail = async (event, phase) => {
        event.stopPropagation();
        setLoading(true);
        
        try {
            const response = await uarService.sendUARFollowUp(phase);
            
            setSnackbarMessage(`Follow-up email sent to ${phase.ROLE_OWNER_FIRST_NAME} ${phase.ROLE_OWNER_LAST_NAME}`);
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            setLoading(false);
        } catch (error) {
            console.error("Error sending follow-up email:", error);
            setSnackbarMessage('Failed to send follow-up email. Please try again.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            setLoading(false);
        }
    };

    const isNotStarted = uarData?.STATUS === 'Not Started';

    const openRolesMapping = (e) => {
        e.preventDefault();

        setOpenRolesSelectModal(true)
    }

  
    // Helper function to check role owner assignments
    const validateRoleOwners = () => {
        const missingRoleOwners = chosenRoles.filter(role => 
            !rolesForReview.some(owner => owner.ROLE_NAME === role.ROLE_NAME)
        );
        
        if (missingRoleOwners.length > 0) {
            // Create a list of role names missing owners
            const roleNames = missingRoleOwners.map(r => r.ROLE_NAME).join(', ');
            
            // Create appropriate message based on number of roles
            let message = missingRoleOwners.length === 1
                ? `Please set up a role owner for the role: ${roleNames}`
                : `Please set up role owners for these roles: ${roleNames}`;
                
            // Add guidance on how to set up role owners
            message += '. To set up role owners, please go to the Application Management section and assign owners to these roles.';
            
            setSnackbarMessage(message);
            setSnackbarSeverity('warning');
            setSnackbarOpen(true);
            return false;
        }
        
        return true;
    };

    const createSODMapping = async () => {
        setLoading(true);
        
        try {
            // First check if the role owners are set up
            const isValid = validateRoleOwners();
            if (!isValid) {
                setLoading(false);
                return;
            }
            
            // Get the in-scope roles for this UAR file
            const inscopeRoles = await uarService.fetchInscopeRolesByUARFile(phase);
            if (!inscopeRoles || inscopeRoles.length === 0) {
                setSnackbarMessage('No in-scope roles found for this UAR. Please define roles first.');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                setLoading(false);
                return;
            }

            // Extract role names from in-scope roles
            const inscopeRoleNames = inscopeRoles.map(role => role.ROLE_NAMES);
            console.log("In-scope role names:", inscopeRoleNames);
            
            // Get all active users from the appRecord
            const allActiveUsers = appRecord.filter(record => record.STATUS !== "Inactive");
            console.log("All active users:", allActiveUsers.length);
            
            // Filter users to only include those with in-scope roles
            let eligibleUsers = [];
            for (const roleName of inscopeRoleNames) {
                const usersWithRole = allActiveUsers.filter(user => user.ROLE_NAME === roleName);
                console.log(`Users with role '${roleName}':`, usersWithRole.length);
                eligibleUsers = [...eligibleUsers, ...usersWithRole];
            }
            
            // Remove any duplicate users (in case a user has multiple in-scope roles)
            eligibleUsers = Array.from(new Map(eligibleUsers.map(user => [user.EMAIL_ADDRESS, user])).values());
            console.log("Total unique eligible users found:", eligibleUsers.length);
            
            if (eligibleUsers.length === 0) {
                setSnackbarMessage('No active users found for the in-scope roles. Please check that users in the application have these roles assigned.');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                setLoading(false);
                return;
            }

            // Prepare a map of role owners by role name for efficient lookup
            const roleOwnersMap = {};
            for (const owner of rolesForReview) {
                if (owner.ROLE_NAME && owner.ROLE_OWNERS) {
                    roleOwnersMap[owner.ROLE_NAME] = owner.ROLE_OWNERS;
                }
            }
            
            // Create a map of role owner emails for SOD checks
            const roleOwnerEmailsMap = {};
            for (const hr of hrList) {
                if (hr.id && hr.EMAIL_ADDRESS) {
                    roleOwnerEmailsMap[hr.id] = hr.EMAIL_ADDRESS.toLowerCase();
                }
            }

            let createdRecordsCount = 0;
            let failedRecords = [];
            let sodViolationsDetected = false;
            
            // Process each eligible user
            for (const user of eligibleUsers) {
                const roleName = user.ROLE_NAME;
                const roleOwnerId = roleOwnersMap[roleName];
                
                if (!roleOwnerId) {
                    console.error(`Role owner not found for ${roleName}`);
                    failedRecords.push(`${roleName} (Missing role owner)`);
                    continue;
                }
                
                // Get role owner details for SOD check
                const roleOwnerDetails = hrList.find(hr => hr.id === roleOwnerId);
                const roleOwnerEmail = roleOwnerDetails?.EMAIL_ADDRESS?.toLowerCase();
                const userEmail = user.EMAIL_ADDRESS?.toLowerCase();
                
                // Check for SOD violation - explicitly compare lowercase emails
                let sod_violation = false;
                if (roleOwnerEmail && userEmail && roleOwnerEmail === userEmail) {
                    console.log(`SOD VIOLATION DETECTED: User ${userEmail} is the same as role owner ${roleOwnerEmail}`);
                    sod_violation = true;
                    sodViolationsDetected = true;
                }
                
                const updated_data = {
                    APP_NAME: id,
                    UAR_FILE: uarData?.id,
                    EMAIL_ADDRESS: user.EMAIL_ADDRESS,
                    REVIEW_CYCLE: uarData?.REVIEW_TAG,
                    ROLE_NAME: roleName,
                    ROLE_OWNER: roleOwnerId,
                    WITH_SOD_VIOLATION: sod_violation,
                };

                try {
                    console.log("Creating UAR SOD record:", updated_data);
                    await uarService.createUARSODRecord(updated_data);
                    createdRecordsCount++;
                } catch (error) {
                    console.error("Error creating SOD record:", error);
                    failedRecords.push(`${user.EMAIL_ADDRESS} (API error)`);
                }
            }
            
            // Only update the status if we successfully created at least one record
            if (createdRecordsCount > 0) {
                const updated_status = {
                    STATUS: 'User List Generated'
                };
                
                await uarService.updateUAR(uarData?.id, updated_status);
                
                // Show appropriate message based on whether SOD violations were detected
                if (sodViolationsDetected) {
                    setSnackbarMessage(`User list generated with ${createdRecordsCount} users. SOD violations detected.`);
                    setSnackbarSeverity('warning');
                } else {
                    setSnackbarMessage(`User list generated successfully (${createdRecordsCount} users processed)`);
                    setSnackbarSeverity('success');
                }
                
                setSnackbarOpen(true);
                
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else {
                setSnackbarMessage('Failed to generate user list. No user records could be created.');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                setLoading(false);
            }
            
        } catch (error) {
            console.error('Error creating checking SOD', error);
            setSnackbarMessage('Failed to generate user list. Please try again.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            setLoading(false);
        }
    };

    // Memoize groupedData calculation
    const groupedData = useMemo(() => {
        return userswithSOD.reduce((acc, user) => {
            const roleName = user.ROLE_NAME || '-';
            const roleOwner = user.ROLE_OWNER;
            const status = user.STATUS;

            // Check if the user has an owner
            const roleOwnerDetails = hrList.find(item => item.id === roleOwner);

            // If the role doesn't exist in the accumulator, initialize it
            if (!acc[roleName]) {
                acc[roleName] = {
                    ROLE_NAME: roleName,
                    ROLE_OWNERS: roleOwnerDetails ? roleOwnerDetails.FIRST_NAME + ' ' + roleOwnerDetails.LAST_NAME : 'Unknown Owner',
                    USER_COUNT: 0,
                    EMAIL_ADDRESS: roleOwnerDetails?.EMAIL_ADDRESS || '',
                    STATUS: status ? status : 'Pending Review',
                    SOD_FLAG: 'No',
                    PROGRESS: 0
                };
            }

            // Increment the USER_COUNT for each role
            acc[roleName].USER_COUNT += 1;

            // Calculate the progress by checking the status
            if (status === 'Approved' || status === 'Rejected') {
                acc[roleName].PROGRESS += 1;
            }

            // Update the SOD_FLAG if the current user has a violation
            if (user.WITH_SOD_VIOLATION === true) {
                acc[roleName].SOD_FLAG = 'Yes';
            }
            
            // Check for SOD violations by comparing email addresses
            // First check the new direct field from the backend (preferred method)
            if (user.ROLE_OWNER_EMAIL && user.EMAIL_ADDRESS) {
                const ownerEmail = user.ROLE_OWNER_EMAIL.toLowerCase();
                const userEmail = user.EMAIL_ADDRESS.toLowerCase();
                
                if (ownerEmail === userEmail) {
                    acc[roleName].SOD_FLAG = 'Yes';
                    user.WITH_SOD_VIOLATION = true;
                }
            } 
            // Fallback to the older method if the new field isn't available
            else if (roleOwnerDetails && roleOwnerDetails.EMAIL_ADDRESS && user.EMAIL_ADDRESS) {
                const ownerEmail = roleOwnerDetails.EMAIL_ADDRESS.toLowerCase();
                const userEmail = user.EMAIL_ADDRESS.toLowerCase();
                
                if (ownerEmail === userEmail) {
                    acc[roleName].SOD_FLAG = 'Yes';
                    user.WITH_SOD_VIOLATION = true;
                }
            }

            return acc;
        }, {});
    }, [userswithSOD, hrList]); // Only recalculate when these dependencies change

    // Memoize groupedDataByRoleOwner calculation
    const groupedDataByRoleOwner = useMemo(() => {
        return userswithSOD.reduce((acc, user) => {
            const roleName = user.ROLE_NAME || '-';
            const roleOwner = user.ROLE_OWNER;
            const status = user.STATUS;
        
            // Check if the user has an owner
            const roleOwnerDetails = hrList.find(item => item.id === roleOwner);
        
            // If the role owner doesn't exist in the accumulator, initialize it
            if (!acc[roleOwner]) {
                acc[roleOwner] = {
                    ROLE_OWNER: roleOwner,
                    ROLE_NAME: roleName,
                    USER_COUNT: 0,
                    EMAIL_ADDRESS: roleOwnerDetails?.EMAIL_ADDRESS || 'Unknown Email',
                    STATUS: status ? status : 'Pending Review',
                    SOD_FLAG: 'No',
                    PROGRESS: 0
                };
            }
        
            // Increment the USER_COUNT for each role owner
            acc[roleOwner].USER_COUNT += 1;
        
            // Calculate the progress by checking the status
            if (status === 'Approved' || status === 'Rejected') {
                acc[roleOwner].PROGRESS += 1;
            }
        
            // Update the SOD_FLAG if the current user has a violation
            if (user.WITH_SOD_VIOLATION === true) {
                acc[roleOwner].SOD_FLAG = 'Yes';
            }
        
            return acc;
        }, {});
    }, [userswithSOD, hrList]); // Only recalculate when these dependencies change

    // Update useEffect to prevent infinite loops
    useEffect(() => {
        const hasSodViolation = Object.values(groupedData).some(role => role.SOD_FLAG === 'Yes');
        setUARSODViolation(hasSodViolation);
    }, [groupedData]); // Now groupedData is memoized, so this won't cause infinite loops

    // Memoize the progress calculations
    useEffect(() => {
        // Calculate the final progress for each role
        for (const roleName in groupedData) {
            const roleData = groupedData[roleName];
            const totalCount = roleData.USER_COUNT;

            if (totalCount > 0) {
                roleData.PROGRESS = ((roleData.PROGRESS / totalCount) * 100).toFixed(0) + '%';
            }
        }

        // Calculate the final progress for each role owner
        for (const roleOwner in groupedDataByRoleOwner) {
            const roleData = groupedDataByRoleOwner[roleOwner];
            const totalCount = roleData.USER_COUNT;

            if (totalCount > 0) {
                roleData.PROGRESS = ((roleData.PROGRESS / totalCount) * 100).toFixed(0) + '%';
            }
        }
    }, [groupedData, groupedDataByRoleOwner]); // Only recalculate when these memoized values change

    // After fetching UAR data and setting up the state...

    const rowsForReview = Object.values(groupedData).map((item, index) => {
        // Find the role in rolesForReview
        const roleInfo = rolesForReview.find(role => 
            role.ROLE_NAME === item.ROLE_NAME || 
            role.ROLE_NAME?.toLowerCase() === item.ROLE_NAME?.toLowerCase()
        );
        
        // Get users for this role
        const usersForRole = userswithSOD.filter(user => 
            user.ROLE_NAME === item.ROLE_NAME ||
            (user.ROLE_NAME?.toLowerCase() === item.ROLE_NAME?.toLowerCase())
        );
        
        // Calculate status counts
        const approvedCount = usersForRole.filter(user => user.STATUS === 'Approved').length;
        const pendingCount = usersForRole.filter(user => user.STATUS === 'Pending Review').length;
        const actionNeededCount = usersForRole.filter(user => user.STATUS === 'Action Needed').length;
        
        return {
        id: index + 1,
        ROLE_NAME: item.ROLE_NAME,
        USER_COUNT: item.USER_COUNT,
            APPROVED_COUNT: approvedCount,
            PENDING_COUNT: pendingCount,
            ACTION_NEEDED_COUNT: actionNeededCount,
            USERS: usersForRole,
            PROGRESS: item.PROGRESS,
            SOD_FLAG: item.SOD_FLAG
        };
    });

    // Using useMemo for all column definitions to avoid redeclarations
    const columnsForReview = useMemo(() => [
        { field: 'id', headerName: '#', width: 50 },
        { field: 'ROLE_NAME', headerName: 'Role Name', flex: 1.5 },
        { field: 'USER_COUNT', headerName: 'Total Users', width: 120 },
        { 
            field: 'APPROVED_COUNT', 
            headerName: 'Approved', 
            width: 120,
            renderCell: (params) => (
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    color: params.value > 0 ? '#4caf50' : 'inherit',
                    fontWeight: params.value > 0 ? 'bold' : 'normal'
                }}>
                    {params.value > 0 && <CheckCircleIcon sx={{ fontSize: 16, mr: 0.5, color: '#4caf50' }} />}
                    {params.value}
                </Box>
            )
        },
        { 
            field: 'PENDING_COUNT', 
            headerName: 'Pending', 
            width: 120,
            renderCell: (params) => (
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    color: params.value > 0 ? '#ff9800' : 'inherit',
                    fontWeight: params.value > 0 ? 'bold' : 'normal'
                }}>
                    {params.value > 0 && <ContentPasteSearchIcon sx={{ fontSize: 16, mr: 0.5, color: '#ff9800' }} />}
                    {params.value}
                </Box>
            )
        },
        { 
            field: 'ACTION_NEEDED_COUNT', 
            headerName: 'Action Needed', 
            width: 140,
            renderCell: (params) => (
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    color: params.value > 0 ? '#f44336' : 'inherit',
                    fontWeight: params.value > 0 ? 'bold' : 'normal'
                }}>
                    {params.value > 0 && <WarningAmberIcon sx={{ fontSize: 16, mr: 0.5, color: '#f44336' }} />}
                    {params.value}
                </Box>
            )
        },
        { 
            field: 'PROGRESS', 
            headerName: 'Progress', 
            flex: 1,
            renderCell: (params) => {
                const progressValue = parseInt(params.value, 10) || 0;
                return (
                    <Box sx={{ width: '100%', mr: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: '70%', mr: 1 }}>
                                <mui.LinearProgress 
                                    variant="determinate" 
                                    value={progressValue} 
                                    sx={{ 
                                        height: 8, 
                                        borderRadius: 5,
                                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                        '& .MuiLinearProgress-bar': {
                                            borderRadius: 5,
                                            backgroundColor: progressValue < 50 ? '#ff9800' : '#4caf50',
                                        }
                                    }}
                                />
                            </Box>
                            <Box sx={{ minWidth: 35 }}>
                                <Typography variant="body2" color="text.secondary">
                                    {params.value}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                );
            }
        },
    ], []);

    // Update the columns for the role review table with better styling and actions
    const columnsWithActionsForReview = useMemo(() => [
        ...columnsForReview,
        {
            field: 'actions',
            headerName: 'View Users',
            width: 120,
            align: 'center',
            headerAlign: 'center',
        renderCell: (params) => {
          const isExpanded = expandedRows.includes(params.row.id);
          
          return (
            <Tooltip title={isExpanded ? "Hide users" : "Show users"}>
              <IconButton
                onClick={(e) => handleReviewDetailsClick(e, params.row)}
                        size="small"
                        sx={{ 
                  color: isExpanded ? 'primary.main' : 'text.secondary',
                            border: '1px solid',
                  borderColor: isExpanded ? 'primary.main' : 'divider',
                            borderRadius: '4px',
                            p: 0.5,
                  backgroundColor: isExpanded ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                            '&:hover': {
                                backgroundColor: 'rgba(25, 118, 210, 0.12)',
                    color: 'primary.main'
                            }
                        }}
                    >
                {isExpanded ? 
                            <KeyboardArrowUpIcon fontSize="small" /> : 
                            <KeyboardArrowDownIcon fontSize="small" />}
                    </IconButton>
                </Tooltip>
          );
        }
      }
    ], [columnsForReview, expandedRows]);

    const rowsByRoleOwner = Object.values(groupedDataByRoleOwner).map((item, index) => {
        const roleOwner = hrList.find(owner => owner.id === item.ROLE_OWNER);
        
        // Get users for this role owner
        const usersForOwner = userswithSOD.filter(user => user.ROLE_OWNER === item.ROLE_OWNER);
        
        // Calculate status counts
        const approvedCount = usersForOwner.filter(user => user.STATUS === 'Approved').length;
        const pendingCount = usersForOwner.filter(user => user.STATUS === 'Pending Review').length;
        const actionNeededCount = usersForOwner.filter(user => user.STATUS === 'Action Needed').length;
    
        return {
            id: index + 1,
            ROLE_OWNER: roleOwner ? roleOwner.FIRST_NAME + ' ' + roleOwner.LAST_NAME : 'Unknown Owner',
            USER_COUNT: item.USER_COUNT,
            APPROVED_COUNT: approvedCount,
            PENDING_COUNT: pendingCount,
            ACTION_NEEDED_COUNT: actionNeededCount,
            PROGRESS: item.PROGRESS,
            OWNERID: item.ROLE_OWNER,
            EMAIL: roleOwner ? roleOwner.EMAIL_ADDRESS : ''
        };
    });

    const columnsByRoleOwner = useMemo(() => [
        { field: 'id', headerName: '#', width: 50 },
        { field: 'ROLE_OWNER', headerName: 'Role Owner', flex: 1.5 },
        { field: 'USER_COUNT', headerName: 'Total Users', width: 120 },
        { 
            field: 'APPROVED_COUNT', 
            headerName: 'Approved', 
            width: 110,
            renderCell: (params) => (
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    color: params.value > 0 ? '#4caf50' : 'inherit',
                    fontWeight: params.value > 0 ? 'bold' : 'normal'
                }}>
                    {params.value > 0 && <CheckCircleIcon sx={{ fontSize: 16, mr: 0.5, color: '#4caf50' }} />}
                    {params.value}
                </Box>
            )
        },
        { 
            field: 'PENDING_COUNT', 
            headerName: 'Pending', 
            width: 110,
            renderCell: (params) => (
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    color: params.value > 0 ? '#ff9800' : 'inherit',
                    fontWeight: params.value > 0 ? 'bold' : 'normal'
                }}>
                    {params.value > 0 && <ContentPasteSearchIcon sx={{ fontSize: 16, mr: 0.5, color: '#ff9800' }} />}
                    {params.value}
                </Box>
            )
        },
        { 
            field: 'ACTION_NEEDED_COUNT', 
            headerName: 'Action Needed', 
            width: 140,
            renderCell: (params) => (
                <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    color: params.value > 0 ? '#f44336' : 'inherit',
                    fontWeight: params.value > 0 ? 'bold' : 'normal'
                }}>
                    {params.value > 0 && <WarningAmberIcon sx={{ fontSize: 16, mr: 0.5, color: '#f44336' }} />}
                    {params.value}
                </Box>
            )
        },
        { 
            field: 'PROGRESS', 
            headerName: 'Progress', 
            flex: 1,
            renderCell: (params) => {
                const progressValue = parseInt(params.value, 10) || 0;
                return (
                    <Box sx={{ width: '100%', mr: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box sx={{ width: '70%', mr: 1 }}>
                                <mui.LinearProgress 
                                    variant="determinate" 
                                    value={progressValue} 
                                    sx={{ 
                                        height: 8, 
                                        borderRadius: 5,
                                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                        '& .MuiLinearProgress-bar': {
                                            borderRadius: 5,
                                            backgroundColor: progressValue < 50 ? '#ff9800' : '#4caf50',
                                        }
                                    }}
                                />
                            </Box>
                            <Box sx={{ minWidth: 35 }}>
                                <Typography variant="body2" color="text.secondary">
                                    {params.value}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                );
            }
        },
    ], []);


    const selectedRows = useMemo(() => {
        // Skip excessive processing and logging for placeholder/empty data
        if (activeUsers.length === 1 && 
            (activeUsers[0].id?.toString().startsWith('no-data') || 
             activeUsers[0].id?.toString().startsWith('error') || 
             activeUsers[0].id?.toString().startsWith('initial') || 
             activeUsers[0].id?.toString().startsWith('refresh'))) {
            // Return a simple placeholder row once
            return [{
                id: 1,
                rowID: activeUsers[0].id,
                FIRST_NAME: activeUsers[0].FIRST_NAME || 'No',
                LAST_NAME: activeUsers[0].LAST_NAME || 'Data',
                EMAIL_ADDRESS: activeUsers[0].EMAIL_ADDRESS || 'No users found',
                ROLE_NAME: activeUsers[0].ROLE_NAME || '-',
                SOD: 'No',
                REVIEWER: 'N/A'
            }];
        }
        
        // Process real data only once per render cycle
        return activeUsers.map((user, index) => {
            const reviewer = userswithSOD?.find(sod => sod.EMAIL_ADDRESS === user.EMAIL_ADDRESS && sod.ROLE_NAME === user.ROLE_NAME);
            const roleOwnerDetails = reviewer ? hrList.find(item => item.id === reviewer.ROLE_OWNER) : null;
            const ownerEmail = reviewer?.ROLE_OWNER_EMAIL || (roleOwnerDetails ? roleOwnerDetails.EMAIL_ADDRESS : '');

            let SOD_CONFLICT = 'No';
            if (ownerEmail && user.EMAIL_ADDRESS && ownerEmail.toLowerCase() === user.EMAIL_ADDRESS.toLowerCase()) {
                SOD_CONFLICT = 'Yes';
            }

            const reviewerName = roleOwnerDetails
                ? `${roleOwnerDetails.EMAIL_ADDRESS}`
                : 'Unknown Reviewer';

            // Get user details from appRecord
            const userDetails = appRecord.find(record => record.EMAIL_ADDRESS === user.EMAIL_ADDRESS);

            return {
                id: index + 1,
                rowID: user.id,
                FIRST_NAME: userDetails?.FIRST_NAME || user.FIRST_NAME || user.first_name || '',
                LAST_NAME: userDetails?.LAST_NAME || user.LAST_NAME || user.last_name || '',
                EMAIL_ADDRESS: user.EMAIL_ADDRESS,
                ROLE_NAME: user.ROLE_NAME || '-',
                SOD: SOD_CONFLICT,
                REVIEWER: reviewerName
            };
        });
    }, [activeUsers, userswithSOD, hrList, appRecord]);

    // Enhance selected columns with status indicators
    const selectedColumns = useMemo(() => [
        { field: 'id', headerName: '#', width: 50 },
        { field: 'FIRST_NAME', headerName: 'First Name', flex: 1 },
        { field: 'LAST_NAME', headerName: 'Last Name', flex: 1 },
        { field: 'EMAIL_ADDRESS', headerName: 'Email Address', flex: 1 },
        { field: 'ROLE_NAME', headerName: 'Role Name', flex: 1 },
        { field: 'REVIEWER', headerName: 'Reviewer', flex: 1 },
        { 
            field: 'SOD', 
            headerName: 'SOD Conflict',
            flex: 1,
            renderCell: (params) => {
                return (
                    <Chip 
                        label={params.value || 'No'} 
                        color={params.value === 'Yes' ? 'error' : 'success'} 
                        size="small"
                        variant="outlined"
                    />
                );
            }
        },
    ], []);

    

    const columnsWithActionsSelected = useMemo(() => [
        ...selectedColumns,
        {
            field: 'actions',
            headerName: 'Actions',
            width: 150,
            renderCell: (params) => (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => handleUpdateReviewerClick(e, params.row)}
                    startIcon={<SettingsIcon />}
                    sx={{ 
                        textTransform: 'none',
                        borderRadius: 2,
                        fontSize: '0.75rem'
                    }}
                >
                    Update Reviewer
                </Button>
            )
        }
    ], [selectedColumns]);



    const renderAuditPrepButton = (params) => {
        const phase = params.row;
        
        return (
            <Tooltip title="View Details" arrow placement="top">
                <IconButton
                        size="small"
                        onClick={(event) => handleClick(event, phase)}
                    sx={{ 
                        bgcolor: 'rgba(33, 150, 243, 0.08)', 
                        '&:hover': { 
                            bgcolor: 'rgba(33, 150, 243, 0.15)'
                        } 
                    }}
                >
                    <ContentPasteSearchIcon sx={{ fontSize: '18px', color: '#2196f3' }} />
                </IconButton>
                </Tooltip>
        );
    };


    // Removed reference to undefined columnsByRole
    // This section can be completely removed if not needed

    const updateRoleOwner = async () => {
        setLoading(true);
        
        try {
            const updatedOwner = await uarService.updateUARSODRecord(selectedUser, updateRoleOwnerData);

            setSnackbarMessage('Role owner updated successfully');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);

            setTimeout(() => {
                window.location.reload();
            }, 1500);

        } catch (error) {
            console.error('Error updating role owner:', error);
            setSnackbarMessage('Failed to update role owner. Please try again.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            setLoading(false);
        }
    };

    const handleConfirmRoles = async () => {
        setOpenConfirmDialog(true);
    };

    const handleConfirmRolesSubmit = async () => {
        setLoading(true);
        setOpenConfirmDialog(false);

        try {
            const updated_status = {
                STATUS: 'Inscope Roles Defined'
            };

            await uarService.updateUAR(uarData?.id, updated_status);

            setSnackbarMessage('Roles confirmed successfully');
            setSnackbarSeverity('success');
            setSnackbarOpen(true);
            
            setTimeout(() => {
                window.location.reload();
            }, 1500);

        } catch (error) {
            console.error('Error confirming roles:', error);
            setSnackbarMessage('Failed to confirm roles. Please try again.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            setLoading(false);
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    // Toggle the SOD violations filter
    const toggleSodFilter = () => {
        setShowOnlySodViolations(!showOnlySodViolations);
    };
    
    // Update the filtered rows whenever rowsForReview change or filter state changes
    useEffect(() => {
        if (showOnlySodViolations) {
            // Use rowsForReview instead of undefined rows
            setFilteredRows(rowsForReview.filter(row => row.SOD_FLAG === 'Yes'));
        } else {
            setFilteredRows(rowsForReview);
        }
    }, [rowsForReview, showOnlySodViolations]);

    const uar_steps = [
        {
            id: 1,
            name: 'Configure Roles',
            description: 'Define roles to review',
            href: '#',
            status: stepOne
        },
        {
            id: 2,
            name: 'Generate Users',
            description: 'Capture up-to-date user list',
            href: '#',
            status: stepTwo
        },
        {
            id: 3,
            name: 'Verify Completeness',
            description: 'C&A Check',
            href: '#',
            status: stepThree
        },
        {
            id: 4,
            name: 'Resolve Segregation of Duties',
            description: 'Address SOD issues',
            href: '#',
            status: stepFour
        },
        {
            id: 5,
            name: 'Start UAR',
            description: 'Submit UAR to Review Owners',
            href: '#',
            status: stepFive
        },
    ]

    const customMainContent = (
            <ResponsiveContainer>
                <mui.Box sx={{ padding: '24px' }}>

               
           

                <mui.Breadcrumbs aria-label="breadcrumb">
                        <mui.Link underline="hover" color="inherit" href="/dashboard">
                            <i className="material-icons">home</i>
                        </mui.Link>
                        <mui.Link underline="hover" color="inherit" href="/dashboard">
                            My Dashboard
                        </mui.Link>
                        <mui.Link underline="hover" color="inherit" href="/useraccessreview">
                        User Access Review
                    </mui.Link>

                        <mui.Typography color="text.primary">Review Cycle {uarData?.REVIEW_TAG}</mui.Typography>
                    </mui.Breadcrumbs>

                    <mui.Box sx={{ display: 'flex', alignItems: 'center', mb: 4, mt: 3 }}>
                        <RateReviewIcon sx={{ fontSize: 32, color: 'primary.main', mr: 2 }} />
                        <mui.Box>
                            <mui.Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
                                User Access Review
                            </mui.Typography>
                            <mui.Typography variant="body1" sx={{ color: 'text.secondary' }}>
                                Create and view status of user access reviews for your applications
                            </mui.Typography>
                        </mui.Box>
                    </mui.Box>

                <Separator />

                    {/* Show progress stepper for all states - updated for minimalist design */}
                    {uarData && uarStatus !== 'Review In-Progress' && (
                        <Paper elevation={0} sx={{ px: 3, pt: 2, pb: 3, mb: 3, borderRadius: 2, bgcolor: 'white' }}>
                            <UARSteps steps={uar_steps} />
                        </Paper>
                    )}

                    {/* Different views based on UAR status */}
                {uarStatus === 'Not Started' ? (
                        <Paper elevation={0} sx={{ p: 3, borderRadius: 2, bgcolor: 'white' }}>
                            <Box sx={{ 
                                display: 'flex', 
                                flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                mb: 3
                            }}>
                                <Box sx={{ mb: { xs: 2, sm: 0 } }}>
                                    <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold', color: 'primary.main' }}>
                                        Configure In-Scope Roles
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: '600px' }}>
                                        Select the roles that will be subject to review in Cycle {uarData?.REVIEW_TAG} for {apps?.APP_NAME}.
                                    </Typography>
                                </Box>
                                <Button 
                                    variant="contained" 
                                    color="primary" 
                                    size="large"
                                    startIcon={<AssignmentIndIcon />}
                                    onClick={openRolesMapping}
                                    sx={{ 
                                        py: 1.5, 
                                        px: 3, 
                                        borderRadius: 2,
                                        fontWeight: 'bold',
                                        boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.1)',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                                        },
                                        transition: 'all 0.2s ease-in-out'
                                    }}
                                >
                                    Select Roles For Review
                                </Button>
                            </Box>

                            <Box sx={{ 
                                bgcolor: 'rgba(25, 118, 210, 0.04)', 
                                p: 3, 
                                borderRadius: 2,
                                border: '1px dashed rgba(25, 118, 210, 0.4)',
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                gap: 2,
                                alignItems: 'flex-start'
                            }}>
                                <InfoIcon color="primary" sx={{ fontSize: 40, mt: 1 }} />
                                <Box>
                                    <Typography variant="h6" sx={{ mb: 1, color: 'primary.main' }}>
                                        About this step
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                                        This is the first step in the User Access Review process. You'll need to:
                                    </Typography>
                                    <Box component="ul" sx={{ pl: 2, m: 0 }}>
                                        <Box component="li" sx={{ mb: 1 }}>
                                            <Typography variant="body2">
                                                <strong>Select roles</strong> that need to be reviewed for compliance
                                            </Typography>
                                        </Box>
                                        <Box component="li" sx={{ mb: 1 }}>
                                            <Typography variant="body2">
                                                <strong>Configure role owners</strong> who will review user access
                                            </Typography>
                                        </Box>
                                        <Box component="li">
                                            <Typography variant="body2">
                                                <strong>Confirm your selection</strong> to proceed to the next step
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            <Box sx={{ 
                                display: 'flex', 
                                flexDirection: { xs: 'column', sm: 'row' }, 
                                gap: 2,
                                mt: 3
                            }}>
                                <Card sx={{ flex: 1, borderRadius: 2, border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                                    <CardContent>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                            <Groups sx={{ color: 'primary.main', mr: 1, fontSize: 24 }} />
                                            <Typography variant="h6">
                                                {uniqueRoles || 0}
                                            </Typography>
                                        </Box>
                                        <Typography variant="body2" color="text.secondary">
                                            Total Unique Roles
                                        </Typography>
                                    </CardContent>
                                </Card>

                                <Card sx={{ flex: 1, borderRadius: 2, border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                                    <CardContent>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                            <People sx={{ color: 'primary.main', mr: 1, fontSize: 24 }} />
                                            <Typography variant="h6">
                                                {uniqueUsers || 0}
                                            </Typography>
                                        </Box>
                                        <Typography variant="body2" color="text.secondary">
                                            Total Active Users
                                        </Typography>
                                    </CardContent>
                                </Card>

                                <Card sx={{ flex: 1, borderRadius: 2, border: '1px solid rgba(0, 0, 0, 0.05)' }}>
                                    <CardContent>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                            <PlaylistAddCheck sx={{ color: 'primary.main', mr: 1, fontSize: 24 }} />
                                            <Typography variant="h6">
                                                {chosenRoles?.length || 0}
                                            </Typography>
                                        </Box>
                                        <Typography variant="body2" color="text.secondary">
                                            Selected For Review
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Box>
                        </Paper>
                ) : uarStatus === 'Inscope Roles Defined' ? (
                        <Paper elevation={0} sx={{ p: 3, borderRadius: 2, bgcolor: 'white' }}>
                            <Box sx={{ 
                                display: 'flex', 
                                flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                mb: 3
                            }}>
                                <Box sx={{ mb: { xs: 2, sm: 0 } }}>
                                    <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold', color: 'primary.main' }}>
                                        Extract User List For Review
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: '600px' }}>
                                        This step will generate the list of active users assigned to the roles you selected.
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <Button
                                        variant="outlined"
                                        startIcon={<ArrowBackIcon />}
                                        onClick={() => setOpenRolesSelectModal(true)}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: 1.5,
                                            px: 2.5,
                                            py: 1,
                                            borderColor: 'primary.main',
                                            color: 'primary.main',
                                            '&:hover': {
                                                borderColor: 'primary.dark',
                                                backgroundColor: 'primary.light',
                                            }
                                        }}
                                    >
                                        Modify Role Selection
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        size="large"
                                        startIcon={<People />}
                                        onClick={(e) => {
                                            if (e && e.preventDefault) {
                                                e.preventDefault();
                                            }
                                            
                                            // Validate role owners
                                            if (!validateRoleOwners()) {
                                                return;
                                            }
                                            
                                            // Call the preview dialog open function in UARRoleList component
                                            const previewButton = document.querySelector('[data-preview-users-button="true"]');
                                            if (previewButton) {
                                                previewButton.click();
                                            } else {
                                                // Fallback to original function
                                                createSODMapping(e);
                                            }
                                        }}
                                        sx={{ 
                                            py: 1.5, 
                                            px: 3, 
                                            borderRadius: 2,
                                            fontWeight: 'bold',
                                            boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.1)',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                                            },
                                            transition: 'all 0.2s ease-in-out'
                                        }}
                                    >
                                        Generate User List
                                    </Button>
                                </Box>
                            </Box>

                            <Box sx={{ 
                                bgcolor: 'rgba(25, 118, 210, 0.04)', 
                                p: 3, 
                                borderRadius: 2,
                                border: '1px dashed rgba(25, 118, 210, 0.4)',
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                gap: 2,
                                alignItems: 'flex-start'
                            }}>
                                <InfoIcon color="primary" sx={{ fontSize: 40, mt: 1 }} />
                                <Box>
                                    <Typography variant="h6" sx={{ mb: 1, color: 'primary.main' }}>
                                        User List Generation
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                                        In this step, the system will automatically:
                                    </Typography>
                                    <Box component="ul" sx={{ pl: 2, m: 0 }}>
                                        <Box component="li" sx={{ mb: 1 }}>
                                            <Typography variant="body2">
                                                <strong>Extract all active users</strong> who have the selected roles assigned
                                            </Typography>
                                        </Box>
                                        <Box component="li" sx={{ mb: 1 }}>
                                            <Typography variant="body2">
                                                <strong>Identify potential segregation of duties issues</strong> in the next step
                                            </Typography>
                                        </Box>
                                        <Box component="li">
                                            <Typography variant="body2">
                                                <strong>Associate users with their role owners</strong> for the review process
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>

                            {chosenRoles && chosenRoles.length > 0 && (
                                <Box sx={{ mt: 3 }}>
                                    <Typography variant="h6" sx={{ mb: 2 }}>
                                        Selected Roles for Review ({chosenRoles.length})
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {chosenRoles.map((role, index) => (
                                            <Grid item xs={12} sm={6} md={4} key={index}>
                                                <Card 
                                                    sx={{ 
                                                        height: '100%',
                                                        borderRadius: 2,
                                                        border: '1px solid rgba(0, 0, 0, 0.05)',
                                                        display: 'flex',
                                                        overflow: 'visible'
                                                    }}
                                                >
                                                    <Box 
                                                        sx={{ 
                                                            width: 8, 
                                                            bgcolor: 'primary.main',
                                                            borderTopLeftRadius: 8,
                                                            borderBottomLeftRadius: 8
                                                        }} 
                                                    />
                                                    <CardContent sx={{ flexGrow: 1, pb: 1 }}>
                                                        <Typography variant="subtitle1" component="div" noWrap>
                                                            {role.ROLE_NAME}
                                                        </Typography>
                                                        <Typography variant="body2" color="text.secondary">
                                                            Ready for user extraction
                                                        </Typography>
                                                    </CardContent>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', pr: 2 }}>
                                                        <PlaylistAddCheck sx={{ color: 'success.main' }} />
                                                    </Box>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                            )}
                        </Paper>
                ) : uarStatus === 'User List Generated' ? (
                        <Paper elevation={0} sx={{ p: 3, borderRadius: 2, bgcolor: 'white' }}>
                            <UARCACheck
                                uarFile={uarData}
                                appRecord={appRecord}
                                userswithSOD={userswithSOD}
                                rolesForReview={rolesForReview}
                                chosenRoles={chosenRoles}
                                hrList={hrList} // <-- Add hrList prop here
                                onComplete={() => {
                                    // Refresh the page after completing the C&A check
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1500);
                                }}
                            />
                        </Paper>
                ) : uarStatus === 'CA Check Completed' ? (
                    <Paper elevation={0} sx={{ p: 3, borderRadius: 2, bgcolor: 'white' }}>
                        {/* ... Header Box and Status Banner ... */}
                            <Box sx={{ 
                                display: 'flex', 
                                flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: { xs: 'flex-start', sm: 'center' },
                                justifyContent: 'space-between',
                                mb: 3
                            }}>
                                <Box>
                                    <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold', color: 'primary.main' }}>
                                        Segregation of Duties
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: '600px' }}>
                                        Review and resolve conflicts where users can review their own access
                                    </Typography>
                                </Box>

                                <Box sx={{ mt: { xs: 2, sm: 0 } }}>
                                    <Button 
                                        onClick={handleBackClick} 
                                        variant="outlined" 
                                        sx={{ mr: 2, borderRadius: 2 }}
                                    >
                                        Back
                                    </Button>
                                    <Button 
                                        onClick={handleSendClick} 
                                        variant="contained" 
                                    disabled={uarSODViolation} // Button disabled if there are violations
                                        endIcon={<SendIcon />}
                                        sx={{ 
                                            py: 1, 
                                            px: 2, 
                                            borderRadius: 2,
                                            fontWeight: 'bold',
                                            boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.1)',
                                            '&:hover': {
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(0, 0, 0, 0.15)',
                                            },
                                            transition: 'all 0.2s ease-in-out',
                                            bgcolor: uarSODViolation ? undefined : '#4caf50'
                                        }}
                                    >
                                        Send for Review
                                    </Button>
                                </Box>
                            </Box>
                            
                            {/* Status Banner */}
                            <Alert 
                                severity={uarSODViolation ? "warning" : "success"} 
                                variant="outlined"
                                icon={uarSODViolation ? <WarningAmberIcon /> : <CheckCircleIcon />}
                            sx={{ mb: 3, borderRadius: 2 /* ... other styles */ }}
                            >
                                <Box sx={{ ml: 1 }}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'medium', color: uarSODViolation ? 'rgb(230, 81, 0)' : 'rgb(27, 94, 32)' }}>
                                    {uarSODViolation ? "SOD Conflicts Found" : "No SOD Conflicts Found"}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: uarSODViolation ? 'rgb(102, 60, 0)' : 'rgb(27, 94, 32)' }}>
                                    {uarSODViolation ? "Some users can review their own access. Resolve all conflicts below before proceeding." : "All user-reviewer assignments are properly segregated. You may proceed with the review."}
                                    </Typography>
                                </Box>
                            </Alert>
                            
                        {/* Summary Cards ... (kept for context, assuming they are correct) ... */}
                            <Grid container spacing={2} sx={{ mb: 3 }}>
                           {/* ... Grid items for summary cards ... */}
                                </Grid>
                                
                        {/* --- Start of Restored SOD Conflict Section --- */}
                            {uarSODViolation && (
                                <Box>
                                    <Typography variant="h6" sx={{ fontWeight: 'medium', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <WarningAmberIcon sx={{ color: 'error.main' }} />
                                        Users with Access Conflicts
                                    </Typography>
                                    
                                <Paper sx={{ mb: 4, overflow: 'hidden', borderRadius: 2, border: '1px solid rgba(0, 0, 0, 0.08)' }}>
                                        <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.08)', bgcolor: 'background.default' }}>
                                            <Typography variant="subtitle2" color="text.secondary">
                                                These users can currently review their own access. Update each reviewer to resolve conflicts.
                                            </Typography>
                                        </Box>
                                        
                                        <Table size="small">
                                            <TableHead sx={{ bgcolor: 'background.default' }}>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'medium' }}>User</TableCell>
                                                    <TableCell sx={{ fontWeight: 'medium' }}>Role</TableCell>
                                                    <TableCell sx={{ fontWeight: 'medium' }}>Current Reviewer</TableCell>
                                                    <TableCell sx={{ fontWeight: 'medium' }}>New Reviewer</TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: 'medium' }}>Action</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                            {(() => {
                                                const conflictUsers = userswithSOD.filter(user => user.WITH_SOD_VIOLATION === true);
                                                console.log(`Rendering conflict table. Found ${conflictUsers.length} conflict users.`);
                                                console.log("Props available for ConflictUserRow:", { hrList: !!hrList, roleOwnerList: !!roleOwnerList, appRecord: !!appRecord });

                                                if (!userswithSOD || userswithSOD.length === 0) {
                                                    console.warn("userswithSOD is empty or undefined when trying to render conflict table.");
                                                    return (
                                                         <TableRow><TableCell colSpan={5} align="center">Loading user data...</TableCell></TableRow>
                                                    );
                                                }

                                                if (conflictUsers.length === 0 && uarSODViolation) {
                                                    console.warn("uarSODViolation is true, but filter found 0 conflict users.");
                                                    return (
                                                        <TableRow><TableCell colSpan={5} align="center">No conflict users found (check data consistency).</TableCell></TableRow>
                                                    );
                                                }

                                                return conflictUsers.map((user, index) => (
                                                    <ConflictUserRow 
                                                        key={user.id || `conflict-${index}`}
                                                        user={user}
                                                        index={index}
                                                        hrList={hrList}
                                                        roleOwnerList={roleOwnerList}
                                                        fetchUARData={fetchUARData}
                                                        uarService={uarService}
                                                        setSnackbarMessage={setSnackbarMessage}
                                                        setSnackbarSeverity={setSnackbarSeverity}
                                                        setSnackbarOpen={setSnackbarOpen}
                                                        appRecord={appRecord}
                                                    />
                                                ));
                                            })()}
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                </Box>
                            )}
                        {/* --- End of Restored SOD Conflict Section --- */}
                            
                            {!uarSODViolation && (
                            <Box sx={{ /* ... styles for no conflicts found box ... */ }}>
                                {/* ... Content for no conflicts found ... */}
                                        </Box>
                                    )}
                        </Paper>
                ) : uarStatus === 'Review In-Progress' ? (
                    <>
                      <UARReviewDashboard 
                        userswithSOD={userswithSOD} 
                        rolesData={rolesForReview || []} 
                        appRecord={appRecord || []} 
                        roleOwnerList={roleOwnerList || []}
                      />
                    </>
                    ) : (
                        <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
                            <Alert severity="info">
                                No data available for the current state ({uarStatus}).
                            </Alert>
                        </Paper>
                    )}
                     </mui.Box>
            </ResponsiveContainer>
           
    );

    const [error, setError] = useState(null);

    // Add a useEffect to ensure data is loaded and userswithSOD is ready before opening the modal
    useEffect(() => {
        if (openUARSetupModal && selectedRole && (!activeUsers.length || !userswithSOD.length)) {
            console.log("Modal opened but data not ready - loading data...");
            
            // Check if we have userswithSOD data
            if (!userswithSOD.length) {
                console.log("Missing userswithSOD data, triggering data load");
                // Reload the UAR data to ensure we have the latest
                fetchUARData().then(() => {
                    console.log("Data reload complete, checking for selected role:", selectedRole);
                    
                    // After data is loaded, find the matching role and populate activeUsers
                    if (userswithSOD.length && selectedRole) {
                        const usersWithRole = userswithSOD.filter(user => user.ROLE_NAME === selectedRole);
                        console.log(`Found ${usersWithRole.length} users with role ${selectedRole} after data reload`);
                        
                        if (usersWithRole.length === 0) {
                            console.log("No users found after reload, checking for similar role names");
                            
                            // Try a more flexible match if exact match failed
                            const roleDetails = getRoleDetails(selectedRole);
                            if (roleDetails) {
                                console.log("Found role by flexible match:", roleDetails);
                                const flexibleUsers = userswithSOD.filter(user => 
                                    user.ROLE_NAME && selectedRole && 
                                    user.ROLE_NAME.toLowerCase() === selectedRole.toLowerCase()
                                );
                                
                                if (flexibleUsers.length > 0) {
                                    console.log(`Found ${flexibleUsers.length} users with case-insensitive role match`);
                                    usersWithRole.push(...flexibleUsers);
                                }
                            }
                            
                            // If still no matches, try to use appRecord as a fallback
                            if (usersWithRole.length === 0 && appRecord && appRecord.length) {
                                const appRecordUsers = appRecord.filter(user => 
                                    user.ROLE_NAME && selectedRole && 
                                    user.ROLE_NAME.toLowerCase() === selectedRole.toLowerCase()
                                );
                                
                                if (appRecordUsers.length > 0) {
                                    console.log(`Found ${appRecordUsers.length} users with role in appRecord`);
                                    const backupUsers = appRecordUsers.map(user => ({
                                        ...user,
                                        id: user.id || Math.random().toString(36).substr(2, 9),
                                        // Add any other necessary fields
                                    }));
                                    
                                    setActiveUsers(backupUsers);
                                    return;
                                }
                            }
                        }
                        
                        // If we have users, enhance them with details
                        if (usersWithRole.length > 0) {
                            const enhancedUsers = usersWithRole.map(user => {
                                const userDetails = appRecord.find(record => record.EMAIL_ADDRESS === user.EMAIL_ADDRESS);
                                return {
                                    ...user,
                                    FIRST_NAME: userDetails?.FIRST_NAME || user.FIRST_NAME || '',
                                    LAST_NAME: userDetails?.LAST_NAME || user.LAST_NAME || '',
                                    EMAIL_ADDRESS: user.EMAIL_ADDRESS,
                                    ROLE_NAME: user.ROLE_NAME,
                                    id: user.id || Math.random().toString(36).substr(2, 9)
                                };
                            });
                            
                            console.log("Setting activeUsers after data reload:", enhancedUsers);
                            setActiveUsers(enhancedUsers);
                        } else {
                            console.log("No users found for this role after all attempts");
                            // Show a message to the user
                            setSnackbarMessage(`No users found with role: ${selectedRole}`);
                            setSnackbarSeverity('info');
                            setSnackbarOpen(true);
                        }
                    }
                }).catch(error => {
                    console.error("Error during data reload:", error);
                    setSnackbarMessage('Error loading user data. Please refresh the page.');
                    setSnackbarSeverity('error');
                    setSnackbarOpen(true);
                });
            }
        }
    }, [openUARSetupModal, selectedRole, userswithSOD.length, activeUsers.length, appRecord]);

    // Utility function to get role details from userswithSOD
    const getRoleDetails = (roleName) => {
        if (!userswithSOD || !userswithSOD.length || !roleName) {
            console.log("Cannot get role details - missing data");
            return null;
        }
        
        // First, try to find the exact role
        const roleDetails = userswithSOD.find(role => role.ROLE_NAME === roleName);
        if (roleDetails) {
            return roleDetails;
        }
        
        // If not found, get any role matching the name (case insensitive)
        const flexMatch = userswithSOD.find(role => 
            role.ROLE_NAME && roleName && 
            role.ROLE_NAME.toLowerCase() === roleName.toLowerCase()
        );
        
        return flexMatch || null;
    };

    const handleClick = async (event, phase) => {
        console.log("View Details clicked for role:", phase.ROLE_NAME);
        
        // Set the modal state variables first
        setOpenUARSetupModal(true);
        setSelectedRole(phase.ROLE_NAME);
        setRoleOwnerEmail(phase.EMAIL_ADDRESS);

        const owner = {
            label: phase.ROLE_OWNERS,
            value: phase.EMAIL_ADDRESS
        };

        setSelectedOwners(owner);

        // Create immediate placeholder data so something shows up while we load
        const initialPlaceholder = [{
            id: `initial-${Date.now()}`,
            EMAIL_ADDRESS: phase.EMAIL_ADDRESS || 'Loading...',
            ROLE_NAME: phase.ROLE_NAME || 'Loading...',
            FIRST_NAME: 'Loading',
            LAST_NAME: 'Data...',
        }];
        
        // Set this immediately so the user sees something right away
        setActiveUsers(initialPlaceholder);

        // If data isn't loaded, fetch it first
        if (!userswithSOD || userswithSOD.length === 0) {
            try {
                console.log("Data not loaded, fetching data first...");
                await fetchUARData();
                // Give time for state to update
                await new Promise(resolve => setTimeout(resolve, 500));
            } catch (error) {
                console.error("Failed to load data:", error);
                setSnackbarMessage('Failed to load required data. Please refresh the page.');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                return;
            }
        }
        
        try {
            // Get users who have this role from userswithSOD
            const usersWithRole = userswithSOD.filter(user => user.ROLE_NAME === phase.ROLE_NAME);
            console.log(`Found ${usersWithRole.length} users with role ${phase.ROLE_NAME}`);
            
            if (usersWithRole.length === 0) {
                // Try case-insensitive search as fallback
                const fuzzyUsers = userswithSOD.filter(user => 
                    user.ROLE_NAME && phase.ROLE_NAME && 
                    user.ROLE_NAME.toLowerCase() === phase.ROLE_NAME.toLowerCase()
                );
                
                if (fuzzyUsers.length > 0) {
                    console.log(`Found ${fuzzyUsers.length} users with case-insensitive role match`);
                    
                    const enhancedFuzzyUsers = fuzzyUsers.map(user => {
                        const userDetails = appRecord ? appRecord.find(record => record.EMAIL_ADDRESS === user.EMAIL_ADDRESS) : null;
                        return {
                            ...user,
                            FIRST_NAME: userDetails?.FIRST_NAME || user.FIRST_NAME || '',
                            LAST_NAME: userDetails?.LAST_NAME || user.LAST_NAME || '',
                            EMAIL_ADDRESS: user.EMAIL_ADDRESS || '',
                            ROLE_NAME: user.ROLE_NAME || '',
                            id: user.id || Math.random().toString(36).substr(2, 9)
                        };
                    });
                    
                    setActiveUsers(enhancedFuzzyUsers);
                    return;
                }
                
                // Try appRecord as final fallback
                if (appRecord && appRecord.length > 0) {
                    const appRecordUsers = appRecord.filter(user => 
                        user.ROLE_NAME && phase.ROLE_NAME && 
                        user.ROLE_NAME.toLowerCase() === phase.ROLE_NAME.toLowerCase()
                    );
                    
                    if (appRecordUsers.length > 0) {
                        console.log(`Found ${appRecordUsers.length} users with role in appRecord`);
                        
                        const backupUsers = appRecordUsers.map((user, index) => ({
                            ...user,
                            id: user.id || `temp-${index}`,
                            EMAIL_ADDRESS: user.EMAIL_ADDRESS || '',
                            ROLE_NAME: user.ROLE_NAME || '',
                            FIRST_NAME: user.FIRST_NAME || '',
                            LAST_NAME: user.LAST_NAME || '',
                        }));
                        
                        console.log("Setting activeUsers from appRecord fallback");
                        setActiveUsers(backupUsers);
                        return;
                    }
                }
                
                // If we get here, really no data was found
                setActiveUsers([{
                    id: `no-data-${Date.now()}`,
                    EMAIL_ADDRESS: 'No users found',
                    ROLE_NAME: phase.ROLE_NAME || '',
                    FIRST_NAME: 'No',
                    LAST_NAME: 'Data',
                }]);
                
                console.warn(`No users found with role ${phase.ROLE_NAME}`);
                setSnackbarMessage(`No users found with role: ${phase.ROLE_NAME}`);
                setSnackbarSeverity('info');
                setSnackbarOpen(true);
                return;
            }
            
            // Enhance users with additional data before setting activeUsers
            const enhancedUsers = usersWithRole.map(user => {
                // Find the full user details from appRecord if available
                const userDetails = appRecord ? appRecord.find(record => record.EMAIL_ADDRESS === user.EMAIL_ADDRESS) : null;
                
                // Include all necessary fields for selectedRows computation
                return {
                    ...user,
                    FIRST_NAME: userDetails?.FIRST_NAME || user.FIRST_NAME || '',
                    LAST_NAME: userDetails?.LAST_NAME || user.LAST_NAME || '',
                    EMAIL_ADDRESS: user.EMAIL_ADDRESS || '',
                    ROLE_NAME: user.ROLE_NAME || '',
                    id: user.id || Math.random().toString(36).substr(2, 9) // Ensure id is available
                };
            });
            
            console.log("Setting activeUsers with enhanced data:", enhancedUsers);
            setActiveUsers(enhancedUsers);
        } catch (error) {
            console.error("Error processing user data:", error);
            setSnackbarMessage('Could not load user data. Please refresh the page and try again.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            
            // Set empty state to communicate the error clearly
            setActiveUsers([{
                id: `error-${Date.now()}`,
                EMAIL_ADDRESS: 'Error loading data',
                ROLE_NAME: phase.ROLE_NAME || '',
                FIRST_NAME: 'Error',
                LAST_NAME: 'Occurred',
            }]);
        }
    };

    // Handle roles changes from UARRoleList component
    const onRolesChanged = (updatedRoles) => {
        console.log("Roles updated, reloading data...");
        fetchUARData();
    };

    // Add a special effect that runs on every render for debugging
    useEffect(() => {
        // Check if we're in a situation where we need user data but don't have it
        if (openUARSetupModal && selectedRole && (!userswithSOD || userswithSOD.length === 0)) {
            console.error("CRITICAL: Modal is open with a selected role but no user data available");
            
            // Force data reload
            fetchUARData()
                .then(() => {
                    console.log("Emergency data reload completed");
                    
                    // If we still don't have data, create emergency placeholder data
                    if (!userswithSOD || userswithSOD.length === 0) {
                        console.log("Creating emergency placeholder data");
                        
                        // Create minimal emergency placeholder data with the selected role
                        const emergencyData = [{
                            id: `emergency-${Date.now()}`,
                            EMAIL_ADDRESS: 'placeholder@example.com',
                            ROLE_NAME: selectedRole,
                            FIRST_NAME: 'Data',
                            LAST_NAME: 'Unavailable',
                        }];
                        
                        setUsersWithSOD(emergencyData);
                        setActiveUsers(emergencyData);
                        
                        // Inform the user
                        setSnackbarMessage('Using fallback data due to loading issues. Some information may be incomplete.');
                        setSnackbarSeverity('warning');
                        setSnackbarOpen(true);
                    }
                })
                .catch((error) => {
                    console.error("Emergency data reload failed:", error);
                });
        }
    });

    // Add additional data loading logic to ensure the app has data when needed
    useEffect(() => {
        // Set up an interval to periodically check if we need to reload data
        const dataCheckInterval = setInterval(() => {
            if ((!userswithSOD || userswithSOD.length === 0) && selectedRole) {
                console.log("Periodic data check: missing user data, reloading...");
                fetchUARData()
                    .then(() => console.log("Periodic data reload completed"))
                    .catch(err => console.error("Periodic data reload failed:", err));
            }
        }, 5000); // Check every 5 seconds
        
        return () => clearInterval(dataCheckInterval);
    }, [userswithSOD, selectedRole]);

    // Function to reload data for a specific role
    const reloadRoleUsers = async (roleName) => {
        try {
            console.log(`Reloading data for role: ${roleName}`);
            
            // Show loading state
            setUsersByRole([{
                id: `refresh-${Date.now()}`,
                ROLE_NAME: roleName,
                FIRST_NAME: 'Refreshing',
                LAST_NAME: 'Data...',
                EMAIL_ADDRESS: 'Please wait while we reload the data',
                STATUS: 'Pending'
            }]);
            
            // Try to reload the UAR data first
            await fetchUARData();
            
            // Allow state to update
            await new Promise(resolve => setTimeout(resolve, 300));
            
            // Debug: Log all the unique role names in userswithSOD for troubleshooting
            if (userswithSOD && userswithSOD.length > 0) {
                const allRoles = [...new Set(userswithSOD.map(user => user.ROLE_NAME))];
                console.log("All available roles after refresh:", allRoles);
            }
            
            // Step 1: Try to find users with EXACT role name match
            let freshUsers = userswithSOD.filter(user => user.ROLE_NAME === roleName);
            console.log(`Found ${freshUsers.length} users with EXACT role match '${roleName}'`);
            
            // Step 2: If no exact matches, try case-insensitive matching
            if (freshUsers.length === 0) {
                console.log("No exact matches, trying case-insensitive matching");
                freshUsers = userswithSOD.filter(user => 
                    user.ROLE_NAME && 
                    user.ROLE_NAME.toLowerCase() === roleName.toLowerCase()
                );
                console.log(`Found ${freshUsers.length} users with case-insensitive role match`);
            }
            
            // Step 3: If still no matches, try trimming whitespace
            if (freshUsers.length === 0) {
                console.log("No case-insensitive matches, trying with trimmed whitespace");
                freshUsers = userswithSOD.filter(user => 
                    user.ROLE_NAME && 
                    user.ROLE_NAME.trim().toLowerCase() === roleName.trim().toLowerCase()
                );
                console.log(`Found ${freshUsers.length} users with trimmed & case-insensitive role match`);
            }
            
            // Step 4: If still no matches, try checking if the role contains the search term
            if (freshUsers.length === 0) {
                console.log("No exact matches, checking if roles contain the search term");
                freshUsers = userswithSOD.filter(user => 
                    user.ROLE_NAME && 
                    user.ROLE_NAME.toLowerCase().includes(roleName.toLowerCase())
                );
                console.log(`Found ${freshUsers.length} users with role containing '${roleName}'`);
            }
            
            // Step 5: Check roleData for expected count and decide if we need to use appRecord
            const matchingRoleData = Object.values(groupedData).find(item => 
                item.ROLE_NAME === roleName || 
                item.ROLE_NAME?.toLowerCase() === roleName?.toLowerCase() ||
                item.ROLE_NAME?.trim().toLowerCase() === roleName?.trim().toLowerCase()
            );
            const expectedCount = matchingRoleData?.USER_COUNT || 0;

            if (freshUsers.length === 0 || (expectedCount > 0 && freshUsers.length !== expectedCount)) {
                console.log(`Using appRecord for role '${roleName}' - expected ${expectedCount} users`);
                
                // Try all the same matching strategies on appRecord
                const exactMatches = appRecord.filter(user => 
                    user.ROLE_NAME === roleName && user.STATUS !== "Inactive"
                );
                
                const caseInsensitiveMatches = appRecord.filter(user => 
                    user.ROLE_NAME && 
                    user.ROLE_NAME.toLowerCase() === roleName.toLowerCase() && 
                    user.STATUS !== "Inactive"
                );
                
                const trimmedMatches = appRecord.filter(user => 
                    user.ROLE_NAME && 
                    user.ROLE_NAME.trim().toLowerCase() === roleName.trim().toLowerCase() && 
                    user.STATUS !== "Inactive"
                );
                
                const containsMatches = appRecord.filter(user => 
                    user.ROLE_NAME && 
                    user.ROLE_NAME.toLowerCase().includes(roleName.toLowerCase()) && 
                    user.STATUS !== "Inactive"
                );
                
                console.log(`AppRecord matches: exact=${exactMatches.length}, case-insensitive=${caseInsensitiveMatches.length}, trimmed=${trimmedMatches.length}, contains=${containsMatches.length}`);
                
                // Use the most specific match that returned results
                const appRecordUsers = exactMatches.length > 0 ? exactMatches : 
                                     caseInsensitiveMatches.length > 0 ? caseInsensitiveMatches :
                                     trimmedMatches.length > 0 ? trimmedMatches :
                                     containsMatches;
                
                console.log(`Found ${appRecordUsers.length} users with role '${roleName}' in appRecord after refresh`);
                
                if (appRecordUsers.length > 0) {
                    // Create proper user objects from appRecord data
                    const fallbackUsers = appRecordUsers.map((user, index) => {
                        // Try to find if this user has a record in userswithSOD to get status info
                        const existingRecord = userswithSOD.find(sodUser => 
                            sodUser.EMAIL_ADDRESS === user.EMAIL_ADDRESS && 
                            (sodUser.ROLE_NAME === user.ROLE_NAME || 
                             sodUser.ROLE_NAME?.toLowerCase() === user.ROLE_NAME?.toLowerCase())
                        );
                        
                        // Find the role owner for this user's role
                        const roleOwnerInfo = rolesForReview.find(role => 
                            role.ROLE_NAME === roleName || 
                            role.ROLE_NAME?.toLowerCase() === roleName?.toLowerCase() ||
                            role.ROLE_NAME?.trim().toLowerCase() === roleName?.trim().toLowerCase()
                        );
                        const roleOwnerId = roleOwnerInfo?.ROLE_OWNERS;
                        const roleOwner = roleOwnerId ? hrList.find(hr => hr.id === roleOwnerId) : null;
                        
                        // Check for SOD violation
                        let sodViolation = false;
                        if (roleOwner && roleOwner.EMAIL_ADDRESS && user.EMAIL_ADDRESS) {
                            if (roleOwner.EMAIL_ADDRESS.toLowerCase() === user.EMAIL_ADDRESS.toLowerCase()) {
                                sodViolation = true;
                            }
                        }
                        
                        return {
                            id: existingRecord?.id || `app-record-${index}-${Math.random().toString(36).substr(2, 5)}`,
                            APP_NAME: id,
                            UAR_FILE: uarData?.id || '',
                            EMAIL_ADDRESS: user.EMAIL_ADDRESS || '',
                            ROLE_NAME: roleName || user.ROLE_NAME || '',  // Use the requested role name for consistency
                            FIRST_NAME: user.FIRST_NAME || '',
                            LAST_NAME: user.LAST_NAME || '',
                            STATUS: existingRecord?.STATUS || 'Pending Review', 
                            ROLE_OWNER: roleOwnerId,
                            WITH_SOD_VIOLATION: existingRecord?.WITH_SOD_VIOLATION || sodViolation,
                            REVIEW_COMPLETED_ON: existingRecord?.REVIEW_COMPLETED_ON || null,
                        };
                    });
                    
                    freshUsers = fallbackUsers;
                    console.log('Using fallback data from appRecord after refresh:', freshUsers);
                }
            }
            
            if (freshUsers.length > 0) {
                setUsersByRole(freshUsers);
                return;
            }
            
            // If we still have no users after all attempts
            setUsersByRole([{
                id: 'no-data',
                ROLE_NAME: roleName,
                FIRST_NAME: 'No',
                LAST_NAME: 'Data',
                EMAIL_ADDRESS: 'No active users found with this role',
                STATUS: 'N/A'
            }]);
            
            setSnackbarMessage(`No users found with role: ${roleName}`);
            setSnackbarSeverity('info');
            setSnackbarOpen(true);
            
        } catch (error) {
            console.error('Error reloading role data:', error);
            setSnackbarMessage('Error refreshing data. Please try again.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        }
    };

  
    return (
        <ErrorBoundary fallback={
            <Box sx={{ p: 3 }}>
                <Alert severity="error">Failed to load data. Please try refreshing the page.</Alert>
            </Box>
        } error={error}>
            <Suspense fallback={
                <Box 
                    sx={{
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        height: '100vh',
                        backgroundColor: '#f8fafc'
                    }}
                >
                    <LogoLoader 
                        size={80} 
                        message="Loading Review Data..." 
                        duration={1.5} 
                    />
                </Box>
            }>
                    <div>
                    <SysOwnerSideBar mainContent={customMainContent} />
                    </div>
            </Suspense>

            {/* Role Assignment Modal */}
                <Modal
                    open={openUARSetupModal}
                    onClose={handleCloseCreateModal}
                header={
                    <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
                        Role Assignment Setup
                    </Typography>
                }
                    size="lg"
                    body={
                    <Box sx={{ p: 1 }}>
                        <Typography variant="subtitle1" sx={{ mt: 2, mb: 1, fontWeight: 'medium' }}>
                                Role Name:
                        </Typography>

                            <NormalTextField
                                label=""
                            name="ROLE_NAME"
                                value={selectedRole}
                            disabled
                            fullWidth
                            InputProps={{
                                sx: { bgcolor: 'rgba(0, 0, 0, 0.03)' }
                            }}
                        />

                        {/* Add header with user count and refresh button */}
                        <Box sx={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            mt: 3, 
                            mb: 1
                        }}>
                            <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                                The following users have <b>{selectedRole}</b> role and will be subject to user access review:
                            </Typography>
                            
                            <Tooltip title="Reload user data" placement="top">
                                <IconButton 
                                    size="small" 
                                    onClick={() => {
                                        // Show loading indicator
                                        setActiveUsers([{
                                            id: `refresh-${Date.now()}`,
                                            EMAIL_ADDRESS: 'Refreshing...',
                                            ROLE_NAME: selectedRole,
                                            FIRST_NAME: 'Loading',
                                            LAST_NAME: 'Data...',
                                        }]);
                                        
                                        // Reload data
                                        fetchUARData()
                                            .then(() => {
                                                // After reload, filter for this role
                                                const roleUsers = userswithSOD.filter(user => 
                                                    user.ROLE_NAME === selectedRole
                                                );
                                                
                                                if (roleUsers.length > 0) {
                                                    setActiveUsers(roleUsers);
                                                } else {
                                                    // Try with appRecord if no users found
                                                    const appRecordUsers = appRecord.filter(user => 
                                                        user.ROLE_NAME === selectedRole
                                                    );
                                                    
                                                    if (appRecordUsers.length > 0) {
                                                        setActiveUsers(appRecordUsers);
                                                    } else {
                                                        // Show no data found message
                                                        setSnackbarMessage(`No users found with role: ${selectedRole}`);
                                                        setSnackbarSeverity('info');
                                                        setSnackbarOpen(true);
                                                    }
                                                }
                                            })
                                            .catch(error => {
                                                console.error("Manual refresh failed:", error);
                                                setSnackbarMessage('Failed to refresh data. Please try again.');
                                                setSnackbarSeverity('error');
                                                setSnackbarOpen(true);
                                            });
                                    }}
                                    sx={{ 
                                        bgcolor: 'primary.light', 
                                        color: 'white',
                                        '&:hover': { bgcolor: 'primary.main' } 
                                    }}
                                >
                                    <RefreshIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        <Suspense fallback={
                            <Box sx={{ width: '100%', my: 2 }}>
                                <mui.LinearProgress />
                            </Box>
                        }>
                                <DataTable
                                    rows={selectedRows}
                                    columns={columnsWithActionsSelected}
                                    columnsWithActions={columnsWithActionsSelected}
                                />
                            </Suspense>
                    </Box>
                    }
                    footer={
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
                        <Button 
                            onClick={handleCloseCreateModal} 
                            variant="contained" 
                            color="primary"
                        >
                                Close
                        </Button>
                    </Box>
                    }
                />

            {/* Mapping Modal */}
            <Modal
                open={openMappingModal}
                size={'md'} // Changed from 'sm' to 'md' for better spacing
                onClose={handleCloseMappingModal}
                header={
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        gap: 1.5
                    }}>
                        <SettingsIcon sx={{ color: 'primary.main' }} />
                        <Box>
                            <Typography variant="h6" sx={{ fontWeight: '600', color: '#1e293b' }}>
                                Update Role Reviewer
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Reassign this user to a different reviewer
                            </Typography>
                        </Box>
                    </Box>
                }
                body={
                    <Box sx={{ p: 2 }}>
                        {/* Info section */}
                        <Box 
                            sx={{ 
                                p: 2.5, 
                                mb: 3, 
                                bgcolor: 'rgba(25, 118, 210, 0.04)', 
                                borderRadius: 2,
                                border: '1px dashed rgba(25, 118, 210, 0.3)'
                            }}
                        >
                            <Typography variant="body2" color="text.secondary" paragraph>
                                <strong>Segregation of Duties (SOD)</strong> requires that users cannot review their own access. 
                                Select a different reviewer to resolve any SOD conflicts.
                            </Typography>
                        </Box>
                        
                        {/* Current Assignment */}
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#1e293b' }}>
                                Current Assignment
                            </Typography>
                            <Box sx={{ 
                                p: 2, 
                                borderRadius: 1, 
                                bgcolor: 'background.paper',
                                border: '1px solid',
                                borderColor: 'divider'
                            }}>
                                {selectedUserEmail && (
                                    <Box sx={{ 
                                        display: 'flex', 
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}>
                                        <Box>
                                            <Typography variant="body2" color="text.primary">
                                                {selectedUserEmail}
                                            </Typography>
                                        </Box>
                                        <Chip 
                                            size="small" 
                                            label="User" 
                                            sx={{ bgcolor: 'primary.light', color: 'primary.contrastText' }} 
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Box>
                        
                        {/* New Selection */}
                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: '#1e293b' }}>
                            New Reviewer Assignment
                        </Typography>
                        
                        <Box 
                            sx={{ 
                                '& .react-select__control': {
                                    borderColor: 'rgba(0, 0, 0, 0.23)',
                                    borderRadius: 1,
                                    boxShadow: 'none',
                                    minHeight: 56,
                                    '&:hover': {
                                        borderColor: 'rgba(0, 0, 0, 0.87)'
                                    }
                                },
                                '& .react-select__menu': {
                                    zIndex: 9999,
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                    borderRadius: 1,
                                    mt: 0.5
                                },
                                '& .react-select__option': {
                                    padding: '10px 12px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.08)'
                                    }
                                },
                                '& .react-select__option--is-selected': {
                                    backgroundColor: 'primary.main',
                                    color: 'white'
                                },
                                '& .react-select__placeholder': {
                                    color: 'text.disabled'
                                }
                            }}
                        >
                            <MultipleSelect
                                isMultiSelect={false}
                                placeholderText="Select a reviewer"
                                selectedOptions={updatedRoleOwner}
                                selectOptions={roleOwnerList.filter(option => option.email.toLowerCase() !== selectedUserEmail.toLowerCase())}
                                handleChange={handleRoleOwnerUpdate}
                                className="role-owner-select"
                            />
                        </Box>
                    </Box>
                }
                footer={
                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'flex-end', 
                        alignItems: 'center',
                        p: 2,
                        borderTop: '1px solid',
                        borderColor: 'divider'
                    }}>
                        <Box sx={{ display: 'flex', gap: 1.5 }}>
                            <Button 
                                onClick={handleCloseMappingModal} 
                                variant="outlined"
                                sx={{ 
                                    py: 1,
                                    px: 2.5,
                                    borderRadius: 1.5,
                                    textTransform: 'none',
                                    fontWeight: 500
                                }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                onClick={updateRoleOwner} 
                                variant="contained" 
                                color="primary"
                                disabled={!updatedRoleOwner || (updatedRoleOwner && updatedRoleOwner.value === selectedUserEmail)}
                                sx={{ 
                                    py: 1,
                                    px: 2.5,
                                    borderRadius: 1.5,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    boxShadow: '0 4px 10px rgba(25, 118, 210, 0.15)'
                                }}
                            >
                                Update Reviewer
                            </Button>
                        </Box>
                    </Box>
                }
            />

            {/* Roles Select Modal */}
                <Modal
                    open={openRolesSelectModal}
                    size={'lg'}
                    onClose={handleCloseRolesSelectModal}
                header={
                    <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        py: 1,
                        mb: -1
                    }}>
                        <PlaylistAddCheck sx={{ 
                            color: 'primary.main', 
                            mr: 1.5, 
                            fontSize: 28 
                        }} />
                        <Box>
                            <Typography variant="h6" sx={{ 
                                fontWeight: 600,
                                color: '#1e293b',
                                letterSpacing: '-0.02em'
                            }}>
                                Select Roles for Review
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Cycle {uarData?.REVIEW_TAG} for {apps?.APP_NAME}
                            </Typography>
                        </Box>
                    </Box>
                }
                    body={
                    <Box>
                        <Box sx={{ 
                            display: 'flex', 
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2
                        }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                Available Roles ({uniqueRolesList.length || 0})
                            </Typography>
                            <Chip 
                                label={`${chosenRoles?.length || 0} roles selected`} 
                                color="primary" 
                                size="small"
                                variant={chosenRoles?.length > 0 ? "filled" : "outlined"}
                                sx={{ fontWeight: 500 }}
                            />
                        </Box>
                        
                        <Box sx={{ 
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 2,
                            overflow: 'hidden',
                            height: '550px', // Increased height to accommodate all content
                            boxShadow: '0 2px 5px rgba(0,0,0,0.05) inset',
                            bgcolor: 'background.paper',
                            position: 'relative'
                        }}>
                            <UARRoleList
                                roles={uniqueRolesList}
                                roleschosen={chosenRoles}
                                app_name={apps?.id}
                                review_cycle={uarData?.REVIEW_TAG}
                                uarfile={uarData?.id}
                                onRolesChanged={onRolesChanged}
                                appRecord={appRecord}
                            />
                            
                            {uniqueRolesList.length === 0 && (
                                <Box sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column'
                                }}>
                                    <SearchOffIcon sx={{ fontSize: 40, color: 'text.disabled', mb: 1 }} />
                                    <Typography variant="body2" color="text.secondary">
                                        No roles found for this application
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                        
                        {chosenRoles?.length > 0 && (
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    mt: 3,
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'success.light',
                                    bgcolor: 'success.light',
                                    display: 'flex',
                                    alignItems: 'center',
                                    opacity: 0.9
                                }}
                            >
                                <CheckCircleIcon sx={{ color: 'success.dark', mr: 1.5 }} />
                                <Typography variant="body2" sx={{ fontWeight: 500, color: 'success.dark' }}>
                                    {chosenRoles.length} {chosenRoles.length === 1 ? 'role' : 'roles'} selected for review
                                </Typography>
                            </Paper>
                        )}
                    </Box>
                    }
                    footer={
                    <Box sx={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        p: 1,
                        px: 2, // Added horizontal padding
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        width: '100%' // Ensure full width
                    }}>
                        <Box sx={{ 
                            px: 1, // Add padding to create more space
                            py: 0.5,
                            borderRadius: 1,
                            bgcolor: 'background.default',
                            border: '1px solid',
                            borderColor: 'divider'
                        }}>
                            <Typography variant="caption" color="text.secondary">
                                {chosenRoles?.length} out of {uniqueRolesList.length} roles selected
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}> {/* Container for buttons with spacing */}
                            <Button 
                                onClick={handleCloseRolesSelectModal} 
                                variant="outlined"
                                sx={{ 
                                    py: 1,
                                    px: 3,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 500,
                                }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                onClick={handleConfirmRoles} 
                                variant="contained" 
                                color="primary"
                                disabled={chosenRoles?.length === 0}
                                endIcon={<ArrowForwardIcon />}
                                sx={{ 
                                    py: 1,
                                    px: 3,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)',
                                    '&:hover': {
                                        boxShadow: '0 6px 15px rgba(25, 118, 210, 0.3)',
                                    }
                                }}
                            >
                                Confirm Selection
                            </Button>
                        </Box>
                    </Box>
                }
            />

            {/* Filter By Role Modal */}
                <Modal
                    open={openFilterByRoleModal}
                    onClose={handleCloseFilterByRoleModal}
                header={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Typography variant="h6">
                            Users for Role: {usersByRole[0]?.ROLE_NAME || 'Loading...'}
                        </Typography>
                    </Box>
                }
                size="lg"
                    body={
                    <Box sx={{ px: 2, pt: 1, pb: 2 }}>
                        {/* User listing */}
                        <Box sx={{ mb: 3, maxHeight: '60vh', overflow: 'auto', pr: 1 }}>
                            {usersByRole.length === 0 && (
                                <Box sx={{ textAlign: 'center', py: 6 }}>
                                    <SearchOffIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} />
                                    <Typography variant="subtitle1" color="text.secondary">
                                        No users found with this role
                                </Typography>
                                </Box>
                            )}
                            
                            {usersByRole.length > 0 && usersByRole[0].EMAIL_ADDRESS?.includes('Please wait') && (
                                <Box sx={{ textAlign: 'center', py: 6 }}>
                                    <CircularProgress size={40} sx={{ mb: 2 }} />
                                    <Typography variant="subtitle1">
                                        Loading user data...
                                </Typography>
                                </Box>
                            )}
                            
                            {usersByRole.length > 0 && !usersByRole[0].EMAIL_ADDRESS?.includes('Please wait') && (
                                <>
                                    {/* Role Owners Section */}
                                    <Paper elevation={0} sx={{ 
                                        p: 2, 
                                        mb: 3, 
                                        borderRadius: 1,
                                        border: '1px solid', 
                                        borderColor: 'divider'
                                    }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 2 }}>
                                            Role Owners
                                        </Typography>
                                        
                                        {(() => {
                                            // Get role name
                                            const roleName = usersByRole[0]?.ROLE_NAME;
                                            
                                            // Find role data to get owners
                                            const roleData = rolesForReview.find(role => 
                                                role.ROLE_NAME === roleName
                                            );
                                            
                                            // Get role owner IDs (could be multiple in an array, or a single ID)
                                            const roleOwnerIds = roleData?.ROLE_OWNERS ? 
                                                (Array.isArray(roleData.ROLE_OWNERS) ? 
                                                roleData.ROLE_OWNERS : [roleData.ROLE_OWNERS]) : [];
                                            
                                            // If no owners found
                                            if (roleOwnerIds.length === 0) {
                                                return (
                                                    <Box sx={{ py: 1, display: 'flex', alignItems: 'center' }}>
                                                        <InfoIcon color="action" sx={{ mr: 1, fontSize: 18 }} />
                                                        <Typography variant="body2" color="text.secondary">
                                                            No role owners assigned to this role
                                                        </Typography>
                                                    </Box>
                                                );
                                            }
                                            
                                            // Map the IDs to actual role owner data
                                            return roleOwnerIds.map((ownerId, index) => {
                                                const roleOwner = hrList.find(hr => hr.id === ownerId);
                                                
                                                if (!roleOwner) {
                                                    return (
                                                        <Box key={`missing-owner-${index}`} sx={{ py: 1 }}>
                                                            <Typography variant="body2" color="text.secondary">
                                                                Owner ID: {ownerId} (details not found)
                                                            </Typography>
                                                        </Box>
                                                    );
                                                }
                                                
                                                return (
                                                    <Box 
                                                        key={`owner-${roleOwner.id}`} 
                                                        sx={{ 
                                                            py: 1.5,
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            borderBottom: index < roleOwnerIds.length - 1 ? '1px solid rgba(0,0,0,0.08)' : 'none'
                                                        }}
                                                    >
                                                        <Box>
                                                            <Typography variant="body1">
                                                                {roleOwner.FIRST_NAME} {roleOwner.LAST_NAME}
                                                            </Typography>
                                                            <Typography variant="body2" color="text.secondary">
                                                                {roleOwner.EMAIL_ADDRESS}
                                                            </Typography>
                                                        </Box>
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            startIcon={<EmailIcon />}
                                                            onClick={(e) => handleSendFollowUpEmail(e, { 
                                                                OWNERID: roleOwner.id,
                                                                ROLE_OWNER_FIRST_NAME: roleOwner.FIRST_NAME,
                                                                ROLE_OWNER_LAST_NAME: roleOwner.LAST_NAME
                                                            })}
                                                        >
                                                            Follow-up
                                                        </Button>
                                                    </Box>
                                                );
                                            });
                                        })()}
                                    </Paper>
                                    
                                    {/* Status summary and actions */}
                                    <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box>
                                            <Typography variant="subtitle1">
                                                {usersByRole.length} user(s) with this role
                                        </Typography>
                                            <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                                                <Typography variant="body2" color="text.secondary">
                                                    {usersByRole.filter(u => u.STATUS === 'Approved').length} Approved
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {usersByRole.filter(u => u.STATUS === 'Pending Review').length} Pending
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {usersByRole.filter(u => u.STATUS === 'Action Needed').length} Action Needed
                                                </Typography>
                                            </Box>
                                        </Box>
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<RefreshIcon />}
                                onClick={() => {
                                    const roleName = usersByRole[0]?.ROLE_NAME;
                                    if (roleName) {
                                        reloadRoleUsers(roleName);
                                    }
                                }}
                            >
                                            Refresh
                            </Button>
                        </Box>
                                    
                                    {/* User list with status */}
                                    <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
                                        <Table size="small">
                                            <TableHead sx={{ bgcolor: 'background.default' }}>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>User</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {usersByRole.map((user, index) => (
                                                    <TableRow key={index} sx={{
                                                        '&:nth-of-type(odd)': { bgcolor: 'rgba(0, 0, 0, 0.02)' }
                                                    }}>
                                                        <TableCell>
                                                            <Typography variant="body2">
                                                                        {user.FIRST_NAME} {user.LAST_NAME}
                                        </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" sx={{ fontSize: '0.8125rem' }}>
                                                                        {user.EMAIL_ADDRESS}
                                        </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <StatusChip status={user.STATUS || 'Pending Review'} />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                </>
                            )}
                                    </Box>
                    </Box>
                }
                footer={
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button 
                            variant="contained" 
                            onClick={handleCloseFilterByRoleModal}
                        >
                            Close
                        </Button>
                    </Box>
                }
            />

            {/* Mapping Modal */}
            <Modal
                open={openMappingModal}
                size={'sm'}
                onClose={handleCloseMappingModal}
                header={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <SettingsIcon sx={{ color: 'error.main' }} />
                        <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
                            Resolve Conflict
                        </Typography>
                    </Box>
                }
                body={
                    <Box sx={{ p: 2 }}>
                        {/* User info */}
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="body2" color="error.main" sx={{ fontWeight: 'medium', mb: 2, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <WarningAmberIcon fontSize="small" />
                                User cannot review their own access
                            </Typography>
                            
                            <Card sx={{ 
                                mb: 2,
                                borderRadius: 2,
                                bgcolor: 'background.default'
                            }}>
                                <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
                                    <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                                        {selectedUserEmail}
                                        </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Currently assigned as both user and reviewer
                                        </Typography>
                                </CardContent>
                            </Card>
                                    </Box>
                        
                        {/* New Selection */}
                        <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
                            Select New Reviewer
                        </Typography>
                        
                        <MultipleSelect
                            isMultiSelect={false}
                            placeholderText="Choose a different reviewer"
                            selectedOptions={updatedRoleOwner}
                            selectOptions={roleOwnerList.filter(option => option.email.toLowerCase() !== selectedUserEmail.toLowerCase())}
                            handleChange={handleRoleOwnerUpdate}
                            className="role-owner-select"
                        />
                        
                        {updatedRoleOwner && (
                            <Alert severity="success" sx={{ mt: 2, mb: 0 }} icon={<CheckCircleIcon />}>
                                <Typography variant="body2">
                                    Valid reviewer selected
                                </Typography>
                            </Alert>
                        )}
                    </Box>
                    }
                    footer={
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1, gap: 1 }}>
                        <Button 
                            onClick={handleCloseMappingModal} 
                            variant="outlined"
                            sx={{ borderRadius: 6 }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            onClick={updateRoleOwner} 
                            variant="contained" 
                            color="success"
                            disabled={!updatedRoleOwner || (updatedRoleOwner && updatedRoleOwner.value === selectedUserEmail)}
                            sx={{ borderRadius: 6 }}
                        >
                            Save
                        </Button>
                    </Box>
                }
            />

            {/* Global loading indicator */}
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* Snackbar for notifications */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert 
                    onClose={handleSnackbarClose} 
                    severity={snackbarSeverity} 
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            {/* Confirmation Dialog */}
            <Dialog
                open={openConfirmDialog}
                onClose={() => setOpenConfirmDialog(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                    }
                }}
            >
                <DialogTitle sx={{ 
                    p: 2,
                    backgroundColor: 'rgba(25, 118, 210, 0.04)', 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Box display="flex" alignItems="center">
                        <VerifiedUserIcon color="primary" sx={{ mr: 1, fontSize: 24 }} />
                        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                            Confirm Role Selection
                        </Typography>
                    </Box>
                    <IconButton edge="end" color="inherit" onClick={() => setOpenConfirmDialog(false)} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 3 }}>
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                            Please review the following roles that will be included in the user access review:
                        </Typography>
                        <Box sx={{ 
                            maxHeight: '300px', 
                            overflowY: 'auto',
                            bgcolor: 'background.default',
                            borderRadius: 1,
                            p: 2,
                            border: '1px solid',
                            borderColor: 'divider'
                        }}>
                            {chosenRoles.map((role, index) => (
                                <Box 
                                    key={index}
                                    sx={{ 
                                        display: 'flex', 
                                        alignItems: 'center',
                                        py: 1,
                                        px: 2,
                                        borderRadius: 1,
                                        bgcolor: 'background.paper',
                                        mb: 1,
                                        '&:last-child': { mb: 0 }
                                    }}
                                >
                                    <CheckCircleIcon color="success" sx={{ mr: 1, fontSize: 20 }} />
                                    <Typography variant="body2">
                                        {role.ROLE_NAME}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                    <Alert severity="info" sx={{ mt: 2 }}>
                        <Typography variant="body2">
                            By confirming, you will proceed to the next step where you can review the users assigned to these roles.
                        </Typography>
                    </Alert>
                </DialogContent>
                <DialogActions sx={{ 
                    px: 3, 
                    py: 2, 
                    borderTop: '1px solid',
                    borderColor: 'divider'
                }}>
                    <Button 
                        onClick={() => setOpenConfirmDialog(false)} 
                        variant="outlined"
                        sx={{ 
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 500
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleConfirmRolesSubmit}
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                        sx={{ 
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.2)',
                            '&:hover': {
                                boxShadow: '0 6px 15px rgba(25, 118, 210, 0.3)',
                            }
                        }}
                    >
                        {loading ? 'Confirming...' : 'Confirm Selection'}
                    </Button>
                </DialogActions>
            </Dialog>
        </ErrorBoundary>
    );
}

export default UserAccessReviewData;